import {
    SECTIONS,
    NOTIFICATION_TYPES,
} from "../../../../config/constants";
import {
    EXTRACTION_STEP_PARAMETERS,
    EXTRACTION_PROCEDURE_NAMES,
    EXTRACTION_IMPORT_TYPES,
    BATCH_PROCESSING_CRON_REPEAT_TYPE,
    BATCH_PROCESSING_OCCURRENCE_TYPE,
    IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS,
    IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS,
    BATCH_PROCESSING_END_TYPE,
    BATCH_PROCESSING_MAP_STATUS_REVERSE,
    BATCH_PROCESSING_MAP_STATUS, CUSTOM_QUERY_PROCEDURE_NAMES, CUSTOM_QUERY_STEP_PARAMETERS,
} from "../../../../config/consts/extraction";
import PageHead from "../../../layout/PageHead";
import {
    Select,
    Button,
    Form,
    Input,
    Divider,
    Checkbox,
    InputNumber,
    Menu,
    Tag,
    Dropdown,
    MenuProps,
    Drawer,
    Space,
    DrawerProps,
    DatePicker,
    Progress,
    List,
    AutoComplete, Modal, Tabs, Spin,
} from "antd";
import "./ProcessOverview.css";
import {
    ApartmentOutlined,
    DownOutlined,
    FlagOutlined,
    EditOutlined,
    MenuOutlined,
    PlusOutlined,
    CheckOutlined,
    CloseOutlined,
    FileTextOutlined,
    CloseCircleOutlined,
    ExperimentOutlined,
    DownloadOutlined,
    SyncOutlined,
    DeleteOutlined,
} from "@ant-design/icons";

import { useEffect, useReducer, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { useTranslation } from "react-i18next";
import BatchProcessingService from "../../../../services/batchprocessing/BatchProcessingService";
import Datatable from "../../../shared/components/Datatable";
import TableDrawer from "../../../shared/components/table-drawer/TableDrawer";
import TableExport from "../../../shared/components/table-export/TableExport";
import { ColumnsType } from "antd/lib/table";
import Title from "antd/lib/typography/Title";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import ProjectSourceService from "../../../../services/projectsources/ProjectSourceService";
import DatabaseService from "../../../../services/databases/DatabaseService";
import ExtractionService from "../../../../services/extraction/ExtractionService";
import { useForm } from "antd/es/form/Form";
import saveAs from "file-saver";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import TextArea from "antd/lib/input/TextArea";
import { useSelector } from "react-redux";
import { QueueStep, QueueTask } from "../../../../models/batchprocessing";
import { SharepointFileNameResponse } from "../../../../models/extraction/SharepointFileNameResponse";
import { ROUTES } from "../../../../config/consts/routes";
import ClusteringService from "../../../../services/clustering/ClusteringService";
import { DATE_TIME_FORMAT_LONG } from "../../../../config/consts/formatting";
import DownloadFile from "../../../shared/utils/DownloadUtil";
import ApplicationService from "../../../../services/application/ApplicationService";
import { GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT } from "../../../../config/consts/appsettings";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import SystemService from "../../../../services/sytem/SystemService";
import { System } from "../../../../models/system/System";

const { TabPane } = Tabs;

const routes = [
    {
        path: ROUTES.general.main.route,
        breadcrumbName: SECTIONS.general.name,
    },
    {
        breadcrumbName: SECTIONS.batchProcessing.name,
    },
    {
        path: ROUTES.batchProcessing.processOverview.route,
        breadcrumbName: ROUTES.batchProcessing.processOverview.name,
    },
];

enum ParameterInputType {
    UserInput = 1,
    Dropdown = 2,
    Readonly = 3,
    Checkbox = 4,
    Dictionary = 6
}

enum ParameterValueType {
    Text = 1,
    Number,
}

interface UpsertTaskModel {
    name: string;
    entity: string;
    groupCode: string;
    stepTemplates: StepTemplateModel[];
    executeImmediate: boolean;
    executionTime: string;
    email: string;
    addAttachment: boolean;
    cronExpression: string;
    recurringJobStartDate: string;
    recurringJobEndDate: string;
}

interface StepTemplateModel {
    parameters: StepTemplateParameterModel[],
    procedure: StepTemplateProcedureModel;
}

interface StepTemplateProcedureModel {
    id: number;
    label: string;
    name: string;
    position: number;
}

interface StepTemplateParameterModel {
    id: number;
    name: string;
    valueTypeId: number;
    inputTypeId: number;
    defaultValue: any;
    listValues: string;
    queryValues: string;
    options: DropdownOptionModel[];
    value: any;
}

interface DropdownOptionModel {
    name: string;
    value: any;
}

interface StepParameterModel {
    id: number;
    name: string;
    value: any;
}

const ProcessOverview = ({ activeProcesses }: { activeProcesses: any }) => {
    const { t, i18n } = useTranslation("translations");

    const { Option } = Select;

    const [data, setData] = useState<any>([]);
    const [groupCodes, setGroupCodes] = useState<any>([]);
    const [categories, setCategories] = useState<any>([]);
    const [entities, setEntities] = useState<any>([]);
    const [operations, setOperations] = useState<any>([]);
    const [selectedGroupCode, setSelectedGroupCode] = useState<any>(-1);
    const [selectedQueryCategory, setSelectedQueryCategory] = useState<any>();
    const [selectedEntity, setSelectedEntity] = useState<any>(-1);
    const [selectedQuery, setSelectedQuery] = useState<any>();
    const [selectedCustomQueryGroupCode, setSelectedCustomQueryGroupCode] = useState<any>();
    const [createTable, setCreateTable] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openResultsDrawer, setOpenResultsDrawer] = useState(false);
    const [placement, setPlacement] =
        useState<DrawerProps["placement"]>("bottom");
    const [taskNameInput, setTaskNameInput] = useState("");
    const [emailInput, setEmailInput] = useState("");
    const [scheduleType, setScheduleType] = useState(BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY);
    const [scheduleDateTime, setScheduleDateTime] = useState<any>(null);
    const [repeatCount, setRepeatCount] = useState<number>(1);
    const [repeatType, setRepeatType] = useState<any>(BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY);
    const [endType, setEndType] = useState(BATCH_PROCESSING_END_TYPE.NEVER);
    const [startDate, setStartDate] = useState<any>(moment());
    const [endDate, setEndDate] = useState<any>();
    const [timeZone, setTimeZone] = useState<any>("CST");
    const [steps, setSteps] = useState<any>([]);
    const [showStepsDrawer, setShowStepsDrawer] = useState<any>(false);
    const [showViewStepsDrawer, setShowViewStepsDrawer] = useState<any>(false);
    const [showViewStepsParamsDrawer, setShowViewParamsStepsDrawer] =
        useState<any>(false);
    const [stepTemplates, setStepTemplates] = useState<any>([]);
    const [selectedStepTemplate, setSelectedStepTemplate] = useState<any>(null);
    const [selectedTask, setSelectedTask] = useState<any>(null);
    const [selectedStepParameters, setSelectedStepParameters] = useState<any>([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [multiSelect, setMultiSelect] = useState<any>(true);
    const [selectable, setSelectable] = useState<any>(true);
    const [selectedRows, setSelectedRows] = useState<any>([]);


    const [editStepIndex, setEditStepIndex] = useState(-1);

    const [selectedStepLogs, setSelectedStepLogs] = useState<any>([]);
    const [selectedStep, setSelectedStep] = useState<any>();
    const [isLogsTableVisible, setIsLogsTableVisible] = useState(false);

    const [buttonLoading, setButtonLoading] = useState(false);
    const [isDrawerLoading, setIsDrawerLoading] = useState(false);

    const defaultCronExpression = "0 0 * * *";
    const [cronExpression, setCronExpression] = useState(defaultCronExpression);

    const [current, setCurrent] = useState(1);
    const [selectedProjectDataSource, setSelectedProjectDataSource] = useState<any>();
    const [selectedDatabaseObject, setSelectedDatabaseObject] = useState<any>();

    const [sourceQuery, setSourceQuery] = useState<any>();
    const [testConnectionState, setTestConnectionState] = useState<any>(null);
    const [databases, setDatabases] = useState<any>([]);
    const [projectSources, setProjectSources] = useState<any>([]);
    const [queryCategories, setQueryCategories] = useState<any>([]);
    const [inputFields, setInputFields] = useState([
        { key: "@sysGroupCode", value: selectedCustomQueryGroupCode, readOnly: true },
        { key: "", value: "", readOnly: false }
    ]);
    const [databaseObjectIsSelected, setDatabaseObjectIsSelected] = useState<any>(false);
    const [query, setQuery] = useState<{ categoryId: any }>({ categoryId: null });
    const [queries, setQueries] = useState<any>([]);
    const [databaseTables, setDatabaseTables] = useState<any>([]);
    const [extractionForm] = useForm();
    const [database, setDatabase] = useState<any>();
    const [isDirty, setIsDirty] = useState<any>(false);
    const [schema, setSchema] = useState<any>();
    const [name, setName] = useState<any>();
    const [importType, setImportType] = useState<any>();
    const [queryTypes, setQueryTypes] = useState<any>([]);


    const [fileRepositoryFileNames, setFileRepositoryFileNames] = useState<string[]>([]);
    const [sharepointFileNames, setSharepointFileNames] = useState<SharepointFileNameResponse[]>([]);
    const [selectedFileName, setSelectedFileName] = useState<string>("");
    const [selectedProjectSource, setSelectedProjectSource] = useState<any>({});
    const [selectedFRProjectDataSource, setSelectedFRProjectDataSource] = useState<any>();

    const [currentResultTask, setCurrentResultTask] = useState<QueueTask>();
    const [currentResultStep, setCurrentResultStep] = useState<QueueStep>();
    const [isResultsTableDataLoading, setIsResultsTableDataLoading] = useState<boolean>(false);
    const [resultsTableData, setResultsTableData] = useState<any>([]); //Of type any because the returned type depends on the backend.
    const [resultsColumns, setResultsColumns] = useState<ColumnsType>([]);
    const [resultsTablePageIndex, setResultsTablePageIndex] = useState<number>(1);
    const [resultsTablePageSize, setResultsTablePageSize] = useState<number>(20);
    const [showExportDrawer, setShowExportDrawer] = useState<boolean>(false);
    const [isDownloadingExportData, setIsDownloadingExportData] = useState<boolean>(false);
    const [queryId, setQueryId] = useState<string | undefined>(undefined);

    const [saveStepAllowed, setSaveStepAllowed] = useState<boolean>(false);

    const [userProcesses, setUserProcesses] = useState<any>([]);
    const [systemProcesses, setSystemProcesses] = useState<any>([]);

    const [logActiveTab, setLogActiveTab] = useState("user-management");

    const [taskGroupCode, setTaskGroupCode] = useReducer(
        (state, action) => reducer(state, action, selectedGroupCode),
        null
    );
    const [taskEntity, setTaskEntity] = useReducer(
        (state, action) => reducer(state, action, selectedEntity),
        null
    );

    const [stepGroupCode, setStepGroupCode] = useReducer(
        (state, action) => reducer(state, action, selectedGroupCode),
        null
    );
    const [stepEntity, setStepEntity] = useReducer(
        (state, action) => reducer(state, action, selectedEntity),
        null
    );

    const { userPermissions } = useSelector((state: any) => ({
        userPermissions: state.userPermissions,
    }));

    const [preferences, setPreferences] = useState<any>();

    const getUserPermissions = (groupCodeName: string, entityName: string) => {
        return userPermissions.find(p => p.groupCodeName === groupCodeName && p.entityName === entityName);
    }

    const importTypes = [
        {
            id: EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT,
            value: EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT
        },
        {
            id: EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY,
            value: EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY
        },
    ];

    const [dictionaryFields, setDictionaryFields] = useState([
        { key: "", value: "", readOnly: false }
    ]);

    const [systems, setSystems] = useState<System[]>([]);
    const [selectedSystemId, setSelectedSystemId] = useState<number>(null);

    useEffect(() => {
        SystemService.getAll()
            .then((res) => {
                setSystems(res.data);
            });
    }, []);

    function reducer(_state, action, defultValue) {
        if (!action) {
            return defultValue;
        }
        return action;
    }

    useEffect(() => {
        if (selectedCustomQueryGroupCode !== undefined) {
            setInputFields([
                { key: "@sysGroupCode", value: selectedCustomQueryGroupCode, readOnly: true },
                { key: "", value: "", readOnly: false }
            ]);
        }
    }, [selectedCustomQueryGroupCode]);


    useEffect(() => {
        if (selectedStepTemplate?.procedure?.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY) {
            const groupCode = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.SELECT_GROUP_CODE)?.value;
            const category = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.SELECT_CATEGORY)?.value;
            const query = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.SELECT_QUERY)?.value;
            const inputFieldsParam = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.INPUT_FIELDS)?.value;

            if (category) {
                setSelectedQueryCategory(parseInt(category, 10));
            }
            setSelectedQuery(query);
            setSelectedCustomQueryGroupCode(groupCode);

            if (Array.isArray(inputFieldsParam)) {
                const mappedInputFields = inputFieldsParam.map((field: any) => ({
                    key: field.key || "",
                    value: field.value || "",
                    readOnly: field.readOnly || false
                }));
                setInputFields(mappedInputFields);
            }

            if (category && groupCode) {
                setCurrent(4);
            } else {
                setCurrent(3);
            }
        }
    }, [selectedStepTemplate]);

    useEffect(() => {
        if (selectedStepTemplate) {
            const inputFieldsParam = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.INPUT_FIELDS)?.value;

            if (Array.isArray(inputFieldsParam)) {
                const mappedInputFields = inputFieldsParam.map((field: any) => ({
                    key: field.key || "",
                    value: field.value || "",
                    readOnly: field.readOnly || false
                }));
                setInputFields(mappedInputFields);
            }
        }
    }, [selectedStepTemplate]);

    useEffect(() => {
        if (selectedStepTemplate) {
            const inputFieldsParam = selectedStepTemplate.parameters.find((x: any) => x.name === CUSTOM_QUERY_STEP_PARAMETERS.INPUT_FIELDS)?.value;

            if (Array.isArray(inputFieldsParam)) {
                const mappedInputFields = inputFieldsParam.map((field: any) => ({
                    key: field.key || "",
                    value: field.value || "",
                    readOnly: field.readOnly || false
                }));
                setInputFields(mappedInputFields);
            }
        }
    }, [selectedStepTemplate]);

    useEffect(() => {
        if (selectedStepTemplate) {
            if (selectedStepTemplate.parameters.some(x => x.isMandatory && !x.value)) {
                setSaveStepAllowed(false);
            }
            else {
                setSaveStepAllowed(true);
            }
        }
    }, [selectedStepTemplate]);

    useEffect(() => {
        document.title = ROUTES.batchProcessing.processOverview.name;
        DatabaseService.getAll().then((response: any) => {
            const data = response.data;
            setDatabases(data);
        });
        ProjectSourceService.getAll().then((response: any) => {
            const data = response.data;
            setProjectSources(data);
        });
        ApplicationService.getCustomQueryCategories().then((response: any) => {
            setQueryCategories(response.data);
        });
        ApplicationService.getCustomQueries().then((response: any) => {
            setQueries(response.data);
        });
        ApplicationService.getPreferences().then((response: any) => {
            const data = response.data;
            setPreferences(data);
        });
    }, []);

    const handleOnDragEnd = (result: any) => {
        if (!result.destination) return;

        const clonedListItems = JSON.parse(JSON.stringify(steps));
        const [reorderedItem] = clonedListItems.splice(result.source.index, 1);
        clonedListItems.splice(result.destination.index, 0, reorderedItem);

        setSteps(clonedListItems);
    };

    const { RangePicker } = DatePicker;

    const onNumberChange = (value: number) => {
        console.log("changed", value);
    };

    useEffect(() => {
        let cronExpression: string;
        if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING) {
            // generate cron expression
            switch (repeatType) {
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.MINUTE:
                    // every nth minute
                    cronExpression = `*/${repeatCount} * * * *`;
                    break;
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.HOUR:
                    // every nth hour
                    cronExpression = `${startDate?.minute()} */${repeatCount} * * *`;
                    break;
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY:
                    // at time on every -nth day
                    cronExpression = `${startDate?.minute()} ${startDate?.hour()} */${repeatCount} * *`;
                    break;
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.WEEK:
                    setRepeatCount(1);
                    // at time on nth day of the week
                    cronExpression = `${startDate?.minute()} ${startDate?.hour()} * * ${startDate?.day()}`;
                    break;
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.MONTH:
                    // at time on day of the month every -nth month
                    cronExpression = `${startDate?.minute()} ${startDate?.hour()} ${startDate?.date()} */${repeatCount} *`;
                    break;
                case BATCH_PROCESSING_CRON_REPEAT_TYPE.YEAR:
                    setRepeatCount(1);
                    // at 00:00 on first day of the year
                    cronExpression = `${startDate?.minute()} ${startDate?.hour()} ${startDate?.date()} ${startDate?.month()} *`;
                    break;
                default:
                    // every minute
                    cronExpression = "* * * * *";
                    break;
            }
        }

        setCronExpression(cronExpression);
    }, [repeatType, repeatCount, startDate, scheduleType]);

    useEffect(() => { }, [scheduleDateTime]);

    useEffect(() => {
        setUserProcesses(data.filter(
            (item: any) => !item.initiator || item.initiator === "User"
        ));
        setSystemProcesses(data.filter(
            (item: any) => item.initiator && item.initiator !== "User"
        ));
    }, [data]);

    const PickerWithType = ({
        type,
        onChange,
    }: {
        type: string;
        onChange: any;
    }) => {
        if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY) {
            return null;
        }
        if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME) {
            return (
                <DatePicker
                    placeholder={
                        t("General.Placeholders.SelectOption", {
                            lngs: i18n.languages,
                            defaultValue: "Select option",
                        })!
                    }
                    value={scheduleDateTime}
                    showTime
                    onChange={setScheduleDateTime}
                    style={{ width: "100%" }}
                />
            );
        }
        if (type === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING) {
            return (
                <>
                    <span>Repeat every:</span>
                    <Space
                        align="center"
                        style={{ width: "100%", marginTop: "5px", marginBottom: "24px" }}
                        className="reccuring_form"
                    >
                        <InputNumber
                            min={1}
                            value={repeatCount}
                            onChange={(x) => setRepeatCount(x)}
                            style={{ width: "20%" }}
                            disabled={repeatType === BATCH_PROCESSING_CRON_REPEAT_TYPE.YEAR || repeatType === BATCH_PROCESSING_CRON_REPEAT_TYPE.WEEK}
                        />
                        <Select
                            style={{ width: "80%" }}
                            placeholder="please select"
                            allowClear
                            value={repeatType}
                            onChange={setRepeatType}
                        >
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.MINUTE}>Minute</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.HOUR}>Hour</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY}>Day</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.WEEK}>Week</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.MONTH}>Month</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.YEAR}>Year</Option>
                        </Select>
                    </Space>
                    <span>Starts:</span>
                    <Space
                        align="center"
                        style={{ width: "100%", marginTop: "5px" }}
                        className="ending_form"
                    >
                        <Input allowClear value={BATCH_PROCESSING_END_TYPE.ON} disabled></Input>
                        <DatePicker
                            showTime
                            style={{ width: "100%" }}
                            value={startDate}
                            onChange={setStartDate}
                        />
                    </Space>
                    <span>Ends:</span>
                    <Space
                        align="center"
                        style={{ width: "100%", marginTop: "5px" }}
                        className="ending_form"
                    >
                        <Select
                            style={{ width: "100%" }}
                            placeholder="please select"
                            allowClear
                            value={endType}
                            onChange={setEndType}
                        >
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY}>Never</Option>
                            <Option value={BATCH_PROCESSING_CRON_REPEAT_TYPE.WEEK}>On</Option>
                        </Select>
                        <DatePicker
                            showTime
                            style={{ width: "100%" }}
                            value={endDate}
                            onChange={setEndDate}
                        />
                    </Space>
                </>
            );
        }
        return <DatePicker onChange={onChange} />;
    };

    useEffect(() => {
        GroupCodesService.getAll().then((response: any) => {
            setGroupCodes(response.data);
        });
        TablesService.getAllEntities().then((response: any) => {
            setEntities(response.data);
        });
        TablesService.getAllOperations().then((response: any) => {
            setOperations(response.data);
        });
    }, []);

    useEffect(() => {
        if (taskGroupCode !== -1 && taskEntity !== -1) {
            const model = {
                entity: entities.find((x: any) => x.id === taskEntity)?.name,
                groupcode: taskGroupCode,
            };
            BatchProcessingService.getAllStepTemplates(model).then(
                (response: any) => {
                    setStepTemplates(response.data);
                }
            );
        }
    }, [taskEntity, taskGroupCode]);

    useEffect(() => {
        if (scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING && !selectedTask) {
            setRepeatCount(1);
            setRepeatType(BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY);
            setStartDate(moment());
            setEndDate(null);
        } else {
            setCronExpression("");
        }
    }, [scheduleType]);

    //Because the columns received from the backend are dynamic, we need to map them ourselves.
    useEffect(() => {
        if (resultsTableData?.length > 0) {
            const columns = Object.keys(resultsTableData[0]);
            setResultsColumns(columns.map(item => ({
                title: item,
                dataIndex: item,
                key: item,
                width: 200,
                filters: [],
                filterMode: "tree",
                filterSearch: true,
                ellipsis: true
            })
            ));
        }
    }, [resultsTableData])

    const handleAddFields = () => {
        setInputFields([...inputFields, { key: "", value: "", readOnly: false }]);
    };

    const handleAddDictionaryField = () => {
        setDictionaryFields([...dictionaryFields, { key: "", value: "", readOnly: false }]);
    };

    const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const values = [...inputFields];
        values[index][event.target.name] = event.target.value;
        setInputFields(values);
    };

    const handleDictionaryInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement>, param: any) => {
        const values = [...dictionaryFields];
        values[index][event.target.name] = event.target.value;
        setDictionaryFields(values);

        const xmlDef = calculateXmlSpec(values);

        const newTemplate = {
            procedure: selectedStepTemplate.procedure,
            parameters: selectedStepTemplate.parameters.map((x: any) => ({
                ...x,
                value: x.id === param.id ? xmlDef : x.value,
            })),
        };
        setSelectedStepTemplate(newTemplate);
    };

    const isDropdown = (inputTypeId: any) => {
        return inputTypeId === ParameterInputType.Dropdown;
    };

    const isDictionary = (inputTypeId: any) => {
        return inputTypeId === ParameterInputType.Dictionary;
    };

    const isUserInput = (inputTypeId: any) => {
        return inputTypeId === ParameterInputType.UserInput;
    };

    const isReadonly = (inputTypeId: any) => {
        return inputTypeId === ParameterInputType.Readonly;
    };

    const calculateXmlSpec = (values: any): string => {
        let xmlString = '<Root><CreateParameter>';

        values.forEach(({ key, value }) => {
            xmlString += `<Parameter Name="${key}" Value="${value}"></Parameter>`;
        });
        xmlString += '</CreateParameter></Root>';

        return xmlString;
    }

    const getParamType = (valueTypeId: any) => {
        if (valueTypeId === ParameterValueType.Number) {
            return ParameterValueType.Number.toString().toLowerCase();
        }
        if (valueTypeId === ParameterValueType.Text) {
            return ParameterValueType.Text.toString().toLowerCase();
        }
    };

    const parseValue = (value: any, valueTypeId: any) => {
        if (valueTypeId === ParameterValueType.Number) {
            if (isNaN(+value)) {
                return value.toString();
            }
            return +value;
        }
        if (valueTypeId === ParameterValueType.Text) {
            return value.toString();
        }
    };

    const onDropdownParamChange = (param: any, value: any) => {
        // eslint-disable-next-line no-param-reassign
        const newTemplate = {
            stepId: selectedStepTemplate.stepId,
            procedure: selectedStepTemplate.procedure,
            parameters: selectedStepTemplate.parameters.map((x: any) => ({
                ...x,
                value: x.id === param.id ? value : x.value,
            })),
        };
        setSelectedStepTemplate(newTemplate);
    };

    const onInputValueChange = (param: any, value: any) => {
        // eslint-disable-next-line no-param-reassign
        const newTemplate = {
            procedure: selectedStepTemplate.procedure,
            parameters: selectedStepTemplate.parameters.map((x: any) => ({
                ...x,
                value: x.id === param.id ? value : x.value,
            })),
        };
        setSelectedStepTemplate(newTemplate);
    };

    const saveStep = () => {
        if (editStepIndex !== -1) {
            let editedStep;
            // Edit step

            // Add step
            if (selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY) {
                editedStep = createCustomQueryStep();
            }
            else if (
                selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE ||
                selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY ||
                selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT) {
                editedStep = createExtractionStep();
            } else {
                editedStep = selectedStepTemplate;
            }

            if (showViewStepsDrawer) {
                // Update step and save it to database - STEP EDIT ON TASK VIEW
                BatchProcessingService.updateStepParameters(editedStep).then(() => {
                    refreshTable();
                    onCloseStepsDrawer();
                    const newStep = selectedTask.steps.find(s => s.id === editedStep.stepId);
                    newStep.parameters = newStep.parameters.map(p => {
                        const editedParameter = editedStep.parameters.find(ep => ep.stepParameterId === p.id);
                        return {
                            ...p,
                            value: editedParameter.value
                        }
                    });
                    let newSteps = selectedTask.steps;
                    newSteps[editStepIndex] = newStep;
                    setSelectedTask((prev) => ({
                        ...prev,
                        steps: [...newSteps]
                    }));
                });
            } else {
                // Update step and update state - TASK EDIT
                let newSteps = steps;
                newSteps[editStepIndex] = editedStep;
                setSteps([...newSteps]);
            }
            onCloseStepsDrawer();
        } else {
            // Add step
            if (selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY) {
                const step = createCustomQueryStep();
                setSteps([...steps, step]);
                setSelectedStepParameters(steps.map((x: any) => x.parameters));
            }
            else if (selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE ||
                selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY ||
                selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT) {
                const step = createExtractionStep();
                setSteps([...steps, step]);
            } else {
                setSteps([...steps, selectedStepTemplate]);
            }
            onCloseStepsDrawer();
        }
    };

    const removeStep = (step: any) => {
        setSteps([...steps.filter((x: any) => x !== step)]);
    };

    const editStep = (step: any, convertStep: boolean = true) => {
        setEditStepIndex(steps.indexOf(step));
        if (convertStep) {
            const matchingStepTemplate = getMatchingStepTemplate(step);
            setSelectedStepTemplate(matchingStepTemplate);
            setSelectedStepParameters(matchingStepTemplate.parameters);
        } else {
            setSelectedStepTemplate(step);
            setSelectedStepParameters(step.parameters);

        }
        openAddStepsDrawer();
    };

    const startTask = (selectedTask: any) => {
        setButtonLoading(true);
        BatchProcessingService.executeTask(selectedTask.id).then(
            (response: any) => {
                refreshTable();
                closeAll();
            }
        );
    };

    const deleteTask = (record: any) => {
        const confirmationMessage = t(
            "Page.BatchProcessing.ProcessOverview.Labels.Delete",
            {
                lngs: i18n.languages,
                defaultValue:
                    `Are you really sure that you want to delete this record (${record.name})?`,
            }
        );
        Modal.confirm({
            title: "Warning",
            content: confirmationMessage,
            onOk() {
                BatchProcessingService.deleteTask(record.id).then(
                    (response: any) => {
                        refreshTable();
                        closeAll();
                    }
                ).catch((error) => {
                    let errorMessage = "Uncaught error has occurred.";
                    if (error.response?.data?.Message) {
                        errorMessage = error.response.data.Message;
                    } else if (error.response?.data) {
                        errorMessage = error.response.data;
                    } else if (error.message) {
                        errorMessage = error.message;
                    } else {
                        errorMessage = error;
                    }

                    NotificationsUtil.openNotificationDialog({
                        description: errorMessage,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                });
            },
        });
    }


    const deleteTasks = () => {
        const confirmationMessage = t(
            "Page.BatchProcessing.ProcessOverview.Labels.DeleteTasks",
            {
                lngs: i18n.languages,
                defaultValue: "Are you really sure that you want to delete the selected tasks?"
            }
        );
        Modal.confirm({
            title: "Warning",
            content: confirmationMessage,
            onOk() {
                BatchProcessingService.deleteTasks(selectedRows.map(x => x.id)).then(
                    (response: any) => {
                        NotificationsUtil.openNotificationDialog({
                            description: t(
                                "Page.BatchProcessing.ProcessOverview.Notifications.DeleteTasks",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "Tasks have been successfully deleted.",
                                }
                            )!,
                            type: NOTIFICATION_TYPES.SUCCESS,
                            logError: false,
                        });
                        refreshTable();
                        closeAll();
                    }
                );
            },
        });
    }

    const startStep = (selectedStep: any) => {
        setButtonLoading(true);
        const task = {
            id: selectedTask.id,
            userId: selectedTask.userId,
            name: selectedTask.name,
            entity: selectedTask.entity,
            groupcode: selectedTask.groupcode,
            executeImmediate: selectedTask.executeImmediate,
            executionTime: selectedTask.executionTime,
            email: selectedTask.email,
            addAttachment: selectedTask.addAttachment,
        };
        const step = {
            id: selectedStep.id,
            taskId: selectedTask.id,
            stepTemplateId: selectedStep.stepTemplateId,
            executionOrder: selectedStep.executionOrder,
        };
        const model = {
            task,
            step,
        };

        BatchProcessingService.executeStep(model).then((response: any) => {
            refreshTable();
            closeAll();
        });
    };

    const cancelTask = (record: any) => {
        setButtonLoading(true);
        BatchProcessingService.cancelTask(record.id).then((response: any) => {
            refreshTable();
            closeAll();
        });
    };

    const cancelStep = (record: any) => {
        const model = {
            stepId: record.id,
            statusId: BATCH_PROCESSING_MAP_STATUS_REVERSE(record.status),
        };

        BatchProcessingService.cancelStep(model).then((response: any) => {
            refreshTable();
            closeAll();
        });
    };

    const closeAll = () => {
        setSelectedTask(null);
        setShowViewStepsDrawer(false);
        setShowStepsDrawer(false);
        setShowViewParamsStepsDrawer(false);
        setButtonLoading(false);
        setOpenDrawer(false);
        setOpenResultsDrawer(false);

        setTaskNameInput("");
        setTaskGroupCode(null);
        setTaskEntity(null);
        setStepGroupCode(null);
        setStepEntity(null);
        setSteps([]);
        setSelectedStepTemplate(null);
        setSelectedStepParameters(null);
        setEmailInput("");
    };


    const getStepStartAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "START",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Start", {
                lngs: i18n.languages,
                defaultValue: "Start",
            }),
            func: startStep,
        };
    }

    const getStepEditAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "EDIT",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Edit", {
                lngs: i18n.languages,
                defaultValue: "Edit",
            }),
            func: editStep,
        };
    }

    const getStepStopAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "STOP",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Stop", {
                lngs: i18n.languages,
                defaultValue: "Stop",
            }),
            func: cancelStep,
        };
    }

    const getStepResultsAction = (record: QueueStep) => {
        if (record.name !== EXTRACTION_PROCEDURE_NAMES.PROCESS_CLUSTERING) {
            return;
        }

        return {
            key: "RESULTS",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Results", {
                lngs: i18n.languages,
                defaultValue: "Results",
            }),
            func: openClusteringStepResultsDrawer,
        };
    }

    const openClusteringStepResultsDrawer = (record: QueueStep) => {
        setCurrentResultTask(selectedTask);
        setCurrentResultStep(record);

        setOpenResultsDrawer(true);

        getResultsData(selectedTask.groupCode, selectedTask.entity, record.batchId);
    }

    const getStepActions = (record: any) => {
        var userPermissions = getUserPermissions(selectedTask?.groupCode, selectedTask?.entity);

        switch (record?.status) {
            case "Success":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                    getStepResultsAction(record),
                ];
            case "Fail":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                ];
            case "Running":
                return [
                    getStepStopAction(userPermissions),
                ];
            case "Scheduled":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                    getStepStopAction(userPermissions),
                ];
            case "In Queue":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                    getStepStopAction(userPermissions),
                ];
            case "Recurring":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                    getStepStopAction(userPermissions),
                ];
            case "Stopped":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                ];
            case "Canceled":
                return [
                    getStepStartAction(userPermissions),
                    getStepEditAction(userPermissions),
                ];
        }
    };

    const getTaskStartAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "START",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Start", {
                lngs: i18n.languages,
                defaultValue: "Start",
            }),
            func: startTask,
        };
    }

    const getTaskEditAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "EDIT",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Edit", {
                lngs: i18n.languages,
                defaultValue: "Edit",
            }),
            func: openEditTaskDrawer,
        };
    }

    const getTaskDeleteAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }
        return {
            key: "DELETE",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Delete", {
                lngs: i18n.languages,
                defaultValue: "Delete",
            }),
            func: deleteTask,
        };


    }
    const getTaskDetailsAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete && !userPermissions?.read) {
            return undefined;
        }

        return {
            key: "DETAILS",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Details", {
                lngs: i18n.languages,
                defaultValue: "Details",
            }),
            func: openViewStepsDrawer,
        };
    }

    const getTaskStopAction = (userPermissions: any) => {
        if (!userPermissions) {
            return undefined;
        }

        if (!userPermissions?.write && !userPermissions?.delete) {
            return undefined;
        }

        return {
            key: "STOP",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Stop", {
                lngs: i18n.languages,
                defaultValue: "Stop",
            }),
            func: cancelTask,
        };
    }

    const getTaskResultsAction = (task: QueueTask) => {
        const clusteringStep = task.steps.find(step => step.name === EXTRACTION_PROCEDURE_NAMES.PROCESS_CLUSTERING);
        if (!clusteringStep) {
            return;
        }

        return {
            key: "RESULTS",
            label: t("Page.BatchProcessing.ProcessOverview.Labels.Results", {
                lngs: i18n.languages,
                defaultValue: "Results"
            }),
            func: openClusteringTaskResultsDrawer
        };
    }

    const getTaskActions = (record: any) => {
        var userPermissions = getUserPermissions(record.groupCode, record.entity);

        switch (record?.status) {
            case "Success":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskResultsAction(record),
                    getTaskDetailsAction(userPermissions),
                    getTaskDeleteAction(userPermissions),
                ];
            case "Fail":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskDetailsAction(userPermissions),
                    getTaskDeleteAction(userPermissions),
                ];
            case "Running":
                return [
                    getTaskStopAction(userPermissions),
                ];
            case "Scheduled":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskStopAction(userPermissions),
                ];
            case "In Queue":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskStopAction(userPermissions),
                ];
            case "Recurring":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskStopAction(userPermissions),
                ];
            case "Stopped":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskDetailsAction(userPermissions),
                    getTaskDeleteAction(userPermissions),
                ];
            case "Canceled":
                return [
                    getTaskStartAction(userPermissions),
                    getTaskEditAction(userPermissions),
                    getTaskDetailsAction(userPermissions),
                    getTaskDeleteAction(userPermissions),
                ];
        }
    };

    useEffect(() => {
        if (selectedGroupCode !== -1 && selectedEntity !== -1) {
            refreshTable();
        }
    }, [selectedEntity, selectedGroupCode]);

    useEffect(() => {
        refreshTable();
    }, [activeProcesses]);

    const getTableData = () => {
        if (selectedGroupCode !== -1 && selectedEntity !== -1) {
            if (selectedGroupCode || selectedEntity) {
                const entityName = entities.find(
                    (x: any) => x.id === selectedEntity
                )?.name;

                BatchProcessingService.getAll(false).then((response: any) => {
                    let data = [];
                    if (response.data.queueTasks) {
                        data = response.data.queueTasks
                            .filter(
                                (x: any) =>
                                    (selectedGroupCode
                                        ? x.groupCode === selectedGroupCode
                                        : true) && (entityName ? x.entity === entityName : true)
                            )
                            .map((x: any) => ({
                                ...x,
                                key: x.id,
                                executionTime: moment.utc(x.executionTime.split(".")[0]).local().format("YYYY-MM-DD HH:mm:ss"),
                                // runtime: x.runtime.split(".")[0].split(":")[0] + ":" + x.runtime.split(".")[0].split(":")[1] + ":" + x.runtime.split(".")[0].split(":")[2]
                                steps: x.steps.map((y: any) => ({
                                    ...y,
                                    executionTime: moment.utc(y.executionTime.split(".")[0]).local().format("YYYY-MM-DD HH:mm:ss"),
                                    status: BATCH_PROCESSING_MAP_STATUS(y.status),
                                })),
                                status: BATCH_PROCESSING_MAP_STATUS(x.status),
                            }));
                    }
                    setData(data);
                    setIsTableLoading(false);
                });
            } else {
                BatchProcessingService.getAll(false).then((response: any) => {
                    const data = response.data.queueTasks.map((x: any) => ({
                        ...x,
                        key: x.id,
                        executionTime: moment.utc(x.executionTime.split(".")[0]).local().format("YYYY-MM-DD HH:mm:ss"),
                        steps: x.steps.map((y: any) => ({
                            ...y,
                            executionTime: moment.utc(y.executionTime.split(".")[0]).local().format("YYYY-MM-DD HH:mm:ss"),
                            status: BATCH_PROCESSING_MAP_STATUS(y.status),
                        })),
                        status: BATCH_PROCESSING_MAP_STATUS(x.status),
                    }));
                    setData(data);
                    setIsTableLoading(false);
                });
            }
        }
    };

    useEffect(() => {
        setTaskGroupCode(selectedGroupCode);
        setStepGroupCode(selectedGroupCode);
    }, [selectedGroupCode]);

    useEffect(() => {
        setTaskEntity(selectedEntity);
        setStepEntity(selectedEntity);
    }, [selectedEntity]);

    interface DataType {
        username: any;
        executionTime: any;
        name: any;
        id: number;
        task: string;
        status: string;
        exeuctionTime: string;
        user: string;
        result: string;
        runtime: string;
        entity: string;
        groupCode: string;
    }

    const columns: ColumnsType<DataType> = [
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.Status", {
                lngs: i18n.languages,
                defaultValue: "Status",
            }),
            dataIndex: "status",
            key: "status",
            filters: [],
            filterMode: "tree",
            sorter: (a, b) => a.status.localeCompare(b.status),

            width: "100px",
            render: (val: any) => (
                <span>
                    <Tag
                        color={
                            val === "Success"
                                ? "#CEF0E7"
                                : val === "Fail"
                                    ? "red"
                                    : "geekblue"
                        }
                        key={val}
                    >
                        {val}
                    </Tag>
                </span>
            ),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.Task", {
                lngs: i18n.languages,
                defaultValue: "Task",
            }),
            dataIndex: "name",
            key: "name",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Table.Headers.ExecutionTime",
                {
                    lngs: i18n.languages,
                    defaultValue: "Execution Time",
                }
            ),
            dataIndex: "executionTime",
            key: "executionTime",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            sorter: (a, b) => moment(a.executionTime, "YYYY-MM-DDTHH:mm:ss", true).unix() - moment(b.executionTime, "YYYY-MM-DDTHH:mm:ss", true).unix(),
            render: (val: any) => (
                <span>
                    {moment(val).format("DD/MM/YYYY")}
                    <br />
                    {moment(val).format("HH:mm:ss")}
                </span>
            ),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.User", {
                lngs: i18n.languages,
                defaultValue: "User",
            }),
            dataIndex: "username",
            key: "username",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            ellipsis: true,
            sorter: (a, b) => a.username.localeCompare(b.username),
            render: (val: any, record: any) => (
                <span>
                    {record.username && record.username.trim() !== "" ? record.username : record.email}
                </span>
            ),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.Entity", {
                lngs: i18n.languages,
                defaultValue: "Entity",
            }),
            dataIndex: "entity",
            key: "entity",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            ellipsis: true,
            sorter: (a, b) => a.entity.localeCompare(b.entity),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.GroupCode", {
                lngs: i18n.languages,
                defaultValue: "Group Code",
            }),
            dataIndex: "groupCode",
            key: "groupCode",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            sorter: (a, b) => a.groupCode.localeCompare(b.groupCode),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.Result", {
                lngs: i18n.languages,
                defaultValue: "Result",
            }),
            dataIndex: "result",
            key: "result",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            render: (_, record: any) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Progress
                            showInfo={false}
                            percent={100}
                            steps={record.steps?.length}
                            strokeColor={record.steps?.map((x: any) =>
                                x.status === "Success"
                                    ? "var(--accent)"
                                    : x.status === "Fail"
                                        ? "#f5222d"
                                        : x.status === "Running"
                                            ? "#2F54EB"
                                            : "#F5F5F5"
                            )}
                        />
                        <span style={{ color: "#8C8C8C" }}>
                            {
                                record.steps?.filter(
                                    (x: any) =>
                                        x.status === "Success" ||
                                        x.status === "Fail" ||
                                        x.status === "Canceled" ||
                                        x.status === "Stopped"
                                ).length
                            }
                            /{record.steps?.length}
                        </span>
                    </div>

                    <div>{/* <span>1 failed</span> */}</div>
                </div>
            ),
        },
        {
            title: t("Page.BatchProcessing.ProcessOverview.Table.Headers.Runtime", {
                lngs: i18n.languages,
                defaultValue: "Runtime",
            }),
            dataIndex: "runtime",
            key: "runtime",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            render: (val: any, record: any) => {
                const timeParts = record?.runtime?.split(':');
                if (timeParts) {
                    const hours = parseInt(timeParts[0], 10);
                    const minutes = parseInt(timeParts[1], 10);
                    const seconds = parseFloat(timeParts[2]);
                    const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
                    const totalHours = Math.floor(totalSeconds / 3600);
                    const remainingSeconds = totalSeconds % 3600;
                    if (totalHours != 0) {
                        return `${totalHours}hrs ${remainingSeconds.toFixed(0)}s`;
                    }
                    return `${remainingSeconds.toFixed(0)}s`;
                }
                return record?.runtime;
            },

        },
    ];

    const stepsColumns: ColumnsType<DataType> = [
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Status",
                {
                    lngs: i18n.languages,
                    defaultValue: "Status",
                }
            ),

            dataIndex: "status",
            key: "status",
            filters: [],
            filterMode: "tree",
            width: "100px",
            render: (val: any) => (
                <span>
                    <Tag
                        color={
                            val === "Success"
                                ? "#CEF0E7"
                                : val === "Fail"
                                    ? "red"
                                    : "geekblue"
                        }
                        key={val}
                    >
                        {val}
                    </Tag>
                </span>
            ),
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Task",
                {
                    lngs: i18n.languages,
                    defaultValue: "Task",
                }
            ),
            dataIndex: "name",
            key: "name",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.ExecutionTime",
                {
                    lngs: i18n.languages,
                    defaultValue: "Execution Time",
                }
            ),
            dataIndex: "executionTime",
            key: "executionTime",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Procedure",
                {
                    lngs: i18n.languages,
                    defaultValue: "Procedure",
                }
            ),
            dataIndex: "procedure",
            key: "procedure",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Params",
                {
                    lngs: i18n.languages,
                    defaultValue: "Params",
                }
            ),
            dataIndex: "params",
            key: "params",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            render: (_, record: any) =>
                record.parameters.every((x) => x === null) ? (
                    <>/</>
                ) : (
                    <Button
                        onClick={() => onViewParametersClick(record)}
                        style={{ color: "#1E1E85" }}
                        type="link"
                        icon={<FileTextOutlined></FileTextOutlined>}
                    >
                        {t("General.Labels.View", {
                            lngs: i18n.languages,
                            defaultValue: "View",
                        })}
                    </Button>
                ),
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Result",
                {
                    lngs: i18n.languages,
                    defaultValue: "Result",
                }
            ),
            dataIndex: "result",
            key: "result",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Steps.Table.Headers.Logs",
                {
                    lngs: i18n.languages,
                    defaultValue: "Logs",
                }
            ),
            dataIndex: "logs",
            key: "logs",
            filters: [],
            filterMode: "tree",
            filterSearch: false,
            render: (_, record: any) =>
                <Button
                    onClick={() => onViewStepLogsClick(record)}
                    style={{ color: "#1E1E85" }}
                    type="link"
                    icon={<FileTextOutlined></FileTextOutlined>}
                >
                    {t("General.Labels.View", {
                        lngs: i18n.languages,
                        defaultValue: "View",
                    })}
                </Button>,
        },
    ];

    const logsColumns: ColumnsType<any> = [
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Logs.Table.Headers.Timestamp",
                {
                    lngs: i18n.languages,
                    defaultValue: "Timestamp",
                }
            ),
            dataIndex: "timestamp",
            key: "timestamp",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            width: "200px",
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Logs.Table.Headers.Procedure",
                {
                    lngs: i18n.languages,
                    defaultValue: "Procedure",
                }
            ),
            dataIndex: "procedure",
            key: "procedure",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
            width: "300px",
        },
        {
            title: t(
                "Page.BatchProcessing.ProcessOverview.Logs.Table.Headers.Message",
                {
                    lngs: i18n.languages,
                    defaultValue: "Message",
                }
            ),
            dataIndex: "message",
            key: "message",
            filters: [],
            filterMode: "tree",
            filterSearch: true,
        },
    ];

    const scroll = { y: "calc(100vh - 380px)" };

    const onTaskNameInputChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        setTaskNameInput(event.target.value);
    };

    const onEmailInputChange: React.ChangeEventHandler<HTMLInputElement> = (
        event
    ) => {
        setEmailInput(event.target.value);
    };

    const handleEntityChange = (value: string) => {
        setTaskEntity(value);
    };

    const handleGroupCodeChange = (value: string) => {
        setTaskGroupCode(value);
    };

    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setOpenDrawer(true);
    };

    const handleMenuClick: MenuProps["onClick"] = (e) => {
        if (e.key === "1") {
            refreshTable();
        }
    };

    const handleRemoveFields = (index: number) => {
        const newFields = inputFields.filter((_, i) => i !== index);
        setInputFields(newFields);
    };

    const handleRemoveDictionaryFields = (index: number) => {
        const newFields = dictionaryFields.filter((_, i) => i !== index);
        setDictionaryFields(newFields);
    };

    const onClose = () => {
        setOpenDrawer(false);
        setTaskNameInput("");
        setEmailInput("");
        setTaskGroupCode(null);
        setTaskEntity(null);
        setStepGroupCode(null);
        setStepEntity(null);
        setSteps([]);
        setSelectedStepTemplate(null);
        setSelectedStepParameters(null);
        setSelectedTask(null);
        setScheduleType(BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY);
        setRepeatCount(1);
        setRepeatType(BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY);
        setStartDate(moment());
        setEndType(BATCH_PROCESSING_END_TYPE.NEVER);
        setEndDate(null);
        setScheduleDateTime(null);
    };

    const openAddStepsDrawer = () => {
        setShowStepsDrawer(true);
    };

    const onCloseStepsDrawer = () => {
        setShowStepsDrawer(false);
        setSelectedStepTemplate(null);
        setSelectedStepParameters(null);
        setSelectedDatabaseObject(null);
        setDatabase(null);
        setEditStepIndex(-1);
        setImportType(null);
        setDatabase(null);
        setSelectedFileName(null);
        setSelectedProjectDataSource(null);
        setSelectedCustomQueryGroupCode(null);
        setSelectedQueryCategory(null);
        setSelectedQuery(null)
        setInputFields([]);
        setDictionaryFields([]);
        setCurrent(1);
    };

    const openViewStepsDrawer = (task: any) => {
        setShowViewStepsDrawer(true);
        setIsDrawerLoading(true);
        BatchProcessingService.getLogs(task.id)
            .then((response) => {
                const steps = task.steps.map((s) => {
                    const logs = response.data.filter((l) => l.batchId === s.batchId);
                    return {
                        ...s,
                        logs: logs,
                    };
                });
                setSteps(steps);
                setSelectedTask({
                    ...task,
                    steps: task.steps.map((s) => {
                        const procedureOutput = response.data.find((l) => l.batchId === s.batchId).procedureOutput;
                        const outputMessages = procedureOutput ? procedureOutput.trim().split("|||") : "";

                        let logs = [];
                        if (outputMessages.length > 0) {
                            logs = outputMessages.map((m) => {
                                if (!m) {
                                    return {};
                                }

                                const messageWithoutEscapingCharacters = m.replace(/[\t]/g, '');
                                if (isNaN(messageWithoutEscapingCharacters[0])) {
                                    return {
                                        message: m
                                    }
                                }

                                const date = m.split(" ")[0];
                                const time = m.split(" ")[1];
                                if (!moment(`${date} ${time}`).isValid()) {
                                    return {
                                        message: m
                                    }
                                }
                                const procedure = m.substring(date?.length + 1 + time?.length)?.trim().split(" ")[0];
                                const message = m.split("=>")[1]?.trim();
                                return {
                                    timestamp: `${date} ${time}`,
                                    procedure,
                                    message
                                }
                            })
                        }
                        let parentLogs = response.data.filter((l) => l.batchId === s.batchId);

                        return {
                            ...s,
                            procedureOutput: procedureOutput,
                            procedureOutputLogs: logs,
                            logs: parentLogs?.length > 0 ? parentLogs[0]?.logs.map((m: any) => {
                                console.log(m);
                                if (m.sql) {
                                    const messageWithoutEscapingCharacters = m.sql.replace(/[\t]/g, '');
                                    if (isNaN(messageWithoutEscapingCharacters[0])) {
                                        return {
                                            message: m.message
                                        }
                                    }
                                }


                                const date = m.startTime.split("T")[0];
                                const time = m.startTime.split("T")[1];
                                if (!moment(`${date} ${time}`).isValid()) {
                                    return {
                                        message: m.message
                                    }
                                }

                                return {
                                    timestamp: `${date} ${time}`,
                                    procedure: m.sql ? m.sql : '',
                                    message: m.message
                                }
                            }) : null
                        };
                    }),
                });

                setIsDrawerLoading(false);
            })
            .catch((error) => {
                let errorMessage = "Uncaught error has occurred.";
                if (error.response?.data?.Message) {
                    errorMessage = error.response.data.Message;
                } else if (error.response?.data) {
                    errorMessage = error.response.data;
                } else if (error.message) {
                    errorMessage = error.message;
                } else {
                    errorMessage = error;
                }

                NotificationsUtil.openNotificationDialog({
                    description: errorMessage,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });

                setIsDrawerLoading(false);
            })
    };

    const getRepeatType = (cronExpression: string): string => {
        const cronExpressionArray = cronExpression.split(" ");
        const numberOfAsterisks = cronExpressionArray.filter(x => x === "*").length;
        switch (numberOfAsterisks) {
            case 4:
                return BATCH_PROCESSING_CRON_REPEAT_TYPE.MINUTE;
            case 3:
                return BATCH_PROCESSING_CRON_REPEAT_TYPE.HOUR;
            case 2:
                if (cronExpressionArray[cronExpressionArray.length - 1] === "*" && cronExpressionArray[cronExpressionArray.length - 2] === "*") {
                    return BATCH_PROCESSING_CRON_REPEAT_TYPE.DAY;
                } else {
                    return BATCH_PROCESSING_CRON_REPEAT_TYPE.WEEK;
                }
            case 1:
                if (cronExpressionArray[cronExpressionArray.length - 2].indexOf("*/") > -1) {
                    return BATCH_PROCESSING_CRON_REPEAT_TYPE.MONTH;
                } else {
                    return BATCH_PROCESSING_CRON_REPEAT_TYPE.YEAR;
                }
        }
    }

    const openEditTaskDrawer = (task: any) => {
        setSelectedTask(task);
        setOpenDrawer(true);
        setTaskNameInput(task.name);
        setTaskGroupCode(task.groupCode);
        setTaskEntity(entities.find(e => e.name === task.entity)?.id);
        setEmailInput(task.email);

        const executionTime = moment.utc(task.executionTime);

        if (!!task.cronExpression) {
            setScheduleType(BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING);
            if (task.cronExpression.indexOf("/") > -1) {
                setRepeatCount(task.cronExpression.split("/")[1].split(" ")[0]);
            }
            setRepeatType(getRepeatType(task.cronExpression));
            setStartDate(moment(task.recurringJobStartDate));
            if (!!task.recurringJobEndDate) {
                setEndType(BATCH_PROCESSING_END_TYPE.ON);
                setEndDate(moment(task.recurringJobEndDate));
            } else {
                setEndType(BATCH_PROCESSING_END_TYPE.NEVER);
            }
        } else if (moment().diff(executionTime) < 0) {
            setScheduleType(BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME);
            setScheduleDateTime(executionTime);
        } else {
            setScheduleType(BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY);
        }

        const steps = task.steps.map((step) => {
            return getMatchingStepTemplate(step);
        });
        setSteps(steps);
    };

    const openClusteringTaskResultsDrawer = (task: QueueTask) => {
        const filteredStep = task.steps.find(step => step.name === EXTRACTION_PROCEDURE_NAMES.PROCESS_CLUSTERING);
        if (!filteredStep) {
            return;
        }

        setCurrentResultTask(task);
        setCurrentResultStep(filteredStep);

        setOpenResultsDrawer(true);

        getResultsData(task.groupCode, task.entity, filteredStep.batchId);
    }

    const getResultsData = (groupCode: string, entity: string, batchId: string) => {
        setIsResultsTableDataLoading(true);

        ClusteringService.getClusteringResults(groupCode, entity, batchId)
            .then(response => {
                setResultsTableData(response.data);
            })
            .catch(error => {
                setResultsTableData([]);
                NotificationsUtil.openNotificationDialog({
                    message: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setIsResultsTableDataLoading(false);
            });
    }

    const downloadTableData = (groupCode: string, rowCount: number) => {
        if (!groupCode || !currentResultTask?.entity || !currentResultStep?.batchId) {
            return;
        }

        setIsDownloadingExportData(true);

        ClusteringService.downloadClusteringResults(groupCode, currentResultTask.entity, currentResultStep.batchId, rowCount)
            .then((response) => {
                const executionTimeString = moment(currentResultStep.executionTime).format(DATE_TIME_FORMAT_LONG);

                DownloadFile(response.data, `ClusteringResults-${currentResultTask.entity}-${groupCode}-${executionTimeString}.xlsx`);
                setShowExportDrawer(false);
            })
            .catch((error) => {
                NotificationsUtil.openNotificationDialog({
                    message: t(
                        "General.Notifications.Labels.DownloadFailed",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Failed to download.",
                        }
                    ),
                    description: error.response.data,
                    placement: "bottomRight",
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: false,
                });
            })
            .finally(() => setIsDownloadingExportData(false));
    }

    const getMatchingStepTemplate = (step) => {
        const stepTemplateMatch: StepTemplateModel = stepTemplates.find((x: any) => x.procedure.id === step.procedureId);

        return {
            stepId: step.id,
            ...stepTemplateMatch,
            parameters: stepTemplateMatch.parameters.map((x) => {
                const stepParameter: StepParameterModel = step.parameters.find((y) => y.name === x.name);
                return {
                    stepParameterId: stepParameter.id,
                    ...x,
                    value: parseValue(stepParameter.value, x.valueTypeId)
                };
            })
        };
    }

    const onCloseViewStepsDrawer = () => {
        setSelectedTask(null);
        setShowViewStepsDrawer(false);
        onCloseViewStepsParamsDrawer();
        onCloseViewStepLogsDrawer();
    };

    const onCloseViewStepLogsDrawer = () => {
        setIsLogsTableVisible(false);
    };

    const openViewStepsParamsDrawer = () => {
        setShowViewParamsStepsDrawer(true);
    };

    const onCloseViewStepsParamsDrawer = () => {
        setShowViewParamsStepsDrawer(false);
    };

    const onViewParametersClick = (record: any) => {
        setSelectedStepParameters(record.parameters);
        openViewStepsParamsDrawer();
    };

    const onViewStepLogsClick = (record: any) => {
        setSelectedStep(record);
        setSelectedStepLogs(record.logs);
        setIsLogsTableVisible(true);
    };

    const refreshTable = () => {
        setIsTableLoading(true);
        getTableData();
    };

    const enableDeleteRows = () => {
        setSelectable(true);
        setMultiSelect(true);
    }

    const disableDeleteRows = () => {
        setSelectable(false);
        setMultiSelect(false);
    }

    const createTask = () => {
        const model = {
            name: taskNameInput,
            entity: entities.find((x: any) => x.id === taskEntity).name,
            groupCode: taskGroupCode,
            stepTemplates: steps,
            executeImmediate: scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY
                ? true
                : false,
            executionTime: scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME
                ? scheduleDateTime?.format()
                : null,
            email: emailInput,
            addAttachment: false,
            cronExpression: cronExpression,
            recurringJobStartDate: scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING
                ? startDate?.format()
                : null,
            recurringJobEndDate: scheduleType === BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING
                ? endDate?.format()
                : null,
        };

        if (selectedTask?.id && (selectedTask?.status === "Scheduled" || selectedTask?.status === "In Queue")) {
            // update
            BatchProcessingService.updateTask(selectedTask.id, model).then((response: any) => {
                refreshTable();
                closeAll();
            });
        } else {
            // create new 
            BatchProcessingService.createTask(model).then((response: any) => {
                refreshTable();
                closeAll();
            });
        }
    };

    const dropdownMenu = (
        <Menu
            className="twoFoldMenu"
            style={{ padding: "10px" }}
            selectable
            onClick={handleMenuClick}
            items={[
                {
                    label: t("Page.BatchProcessing.ProcessOverview.Labels.RefreshTable", {
                        lngs: i18n.languages,
                        defaultValue: "Refresh table",
                    }),
                    key: "1",
                    icon: <FlagOutlined />,
                },
            ]}
        />
    );

    const actionButton = (
        <Space>
            <>
                <Button
                    type="primary"
                    onClick={handleButtonClick}
                    style={{ borderColor: "var(--white)" }}
                >
                    <PlusOutlined />
                    {t("Page.BatchProcessing.ProcessOverview.Labels.ActionNewTask", {
                        lngs: i18n.languages,
                        defaultValue: "NEW TASK",
                    })}
                </Button>
                <Button
                    type="primary"
                    onClick={refreshTable}
                    style={{ borderColor: "var(--white)" }}
                >
                    <SyncOutlined />
                    {t("Page.BatchProcessing.ProcessOverview.Labels.RefreshTable", {
                        lngs: i18n.languages,
                        defaultValue: "Refresh table",
                    })}
                </Button>
                <Button
                    type="ghost"
                    onClick={deleteTasks}
                    disabled={selectedRows?.length === 0}
                    style={{ borderColor: "var(--white)" }}
                >
                    <DeleteOutlined />
                    {t("Page.BatchProcessing.ProcessOverview.Labels.deleteTable", {
                        lngs: i18n.languages,
                        defaultValue: "DELETE",
                    })}
                </Button>
            </>
        </Space>
    );

    const next = () => {
        setCurrent(current + 1);
    };

    const onCustomQueryGroupCodeChange = (value: string) => {
        setSelectedCustomQueryGroupCode(value);
        setInputFields([
            { key: "@sysGroupCode", value: value, readOnly: true }
        ]);
        if (value && value !== "" && current === 1) {
            next();
        }
    };
    const onSelectedQueryCategoryChange = (value: any) => {
        setSelectedQueryCategory(value);
        if (value && value !== "" && current === 1) {
            next();
        }
    };

    const onSelectedQueryChange = (value: string) => {
        setSelectedQuery(value);
        const queryNumber = value.split(' ')[0];
        setQueryId(queryNumber);
    };


    const onCreateTableChange = (e: CheckboxChangeEvent) => {
        const value = e.target.checked;
        setCreateTable(value);
        if (value && current === 3) {
            next();
        }
    };
    const onProjectDataSourceChange = (value: any) => {
        setTestConnectionState(null);
        setSelectedProjectDataSource(value);
        if (value && value !== "" && current === 1) {
            next();
        }
    };

    const onImportTypeChange = (value: any) => {
        setImportType(value);
        if (value && value !== "" && current === 2) {
            next();
        }
    };

    const testConnection = () => {
        const selectedDataSource = projectSources.find(
            (x: any) => x.id.toString() === selectedProjectDataSource
        );

        const model = {
            projectSourceId: selectedDataSource.id.toString(),

        };

        ExtractionService.testConnection(model)
            .then((response: any) => {
                const data = response.data;
                setTestConnectionState(data);
            })
            .catch((error: any) => {
                console.log(error);
                setTestConnectionState(false);
            });
    };

    const onSelectedDatabaseObjectChange = (value: string) => {
        setSelectedDatabaseObject(value);
        setDatabaseObjectIsSelected(false);

        const databaseObjectNames = value?.split(".");
        if (databaseObjectNames?.length === 2) {
            setName(databaseObjectNames[1]);
        }
    };

    const onSelectedDatabaseObjectSelect = (value: string) => {
        if (value !== "") {
            setDatabaseObjectIsSelected(true);
        }
    };

    const downloadProcedureOutput = () => {
        if (logActiveTab == "procedure-output") {
            let url = window.URL.createObjectURL(new Blob([
                selectedStep?.procedureOutput?.replaceAll("|||", "\n")
            ]));
            saveAs(url, `${selectedTask.name} - ${selectedStep.name} - PROCEDURE OUTPUT LOGS.txt`);
        } else {
            // Serialize the log objects into readable lines
            const logLines = (selectedStep?.logs || []).map(log => {
                const timestamp = log.timestamp || '';
                const source = log.procedure || '';
                const message = log.message || '';
                return `${timestamp}   ${source}   => ${message}`;
            }).join('\n');

            let url = window.URL.createObjectURL(new Blob([logLines]));
            saveAs(url, `${selectedTask.name} - ${selectedStep.name} - MAPPING.LOG LOGS.txt`);
        }
    };

    useEffect(() => {
        if (selectedProjectDataSource && projectSources) {
            const selectedDataSource = projectSources.find(
                (x: any) => x.id.toString() === selectedProjectDataSource
            );

            const model = {
                projectSourceId: selectedDataSource?.id.toString(),
            };

            ExtractionService.getTables(model).then((response: any) => {
                setDatabaseTables(response.data);
            });
        }
    }, [projectSources, selectedProjectDataSource]);

    useEffect(() => {
        if (selectedProjectDataSource && databases) {
            setDatabase(databases[0].name);
        }
    }, [selectedProjectDataSource, databases])

    useEffect(() => {
        if (stepEntity && entities) {
            setSchema(entities.find((x: any) => x.id === stepEntity)?.name);
        }
    }, [stepEntity, entities])

    const onGroupCodeChange = (value: string) => {
        setIsDirty(true);
        setStepGroupCode(value);
    };

    const onEntityChange = (value: string) => {
        setIsDirty(true);
        setStepEntity(value);

        const appDefaultDatabase = preferences.find(
            (p) =>
                p.key === GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                p.object === "Application"
        );

        let initialDatabase = null;

        if (value) {
            const entityDefaultDatabase = preferences.find(
                (p) =>
                    p.key === GLOBAL_COMPONENT_SELECT_DATABASE_IMPORT_DEFAULT &&
                    p.object === "Entity" &&
                    p.objectId === value
            );

            if (entityDefaultDatabase) {
                initialDatabase = entityDefaultDatabase.value;
            }
        }

        if (initialDatabase === null) {
            if (appDefaultDatabase) {
                initialDatabase = appDefaultDatabase.value;
            }
        }

        if (initialDatabase === null) {
            if (databases.length === 1) {
                initialDatabase = databases[0].name;
            }
        }

        setDatabase(initialDatabase);
        extractionForm.setFieldsValue({ database: initialDatabase });
    };

    const onSourceQueryChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
        setSourceQuery(event.target.value);
    };

    const onDatabaseChange = (value: string) => {
        setIsDirty(true);
        setDatabase(value);
    };

    const onSchemaChange = (value: string) => {
        setIsDirty(true);
        setSchema(value);
    };

    const onNameChange = (value: string) => {
        setIsDirty(true);
        if (/^[A-Za-z0-9_]*$/.test(value)) {
            setName(value.replace(/\s/g, ""));
        }
    };

    const createExtractionStep = () => {
        if (selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY) {
            return getImportFromFileRepositoryStep();
        }
        if (selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT) {
            return getImportFromSharePointStep();
        }
        if (selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE) {
            return getImportFromMsSqlStep();
        }
    }

    const createCustomQueryStep = () => {
        if (selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY) {
            return getCustomQueryRunSingleQueryStep();
        }
    }

    const getCustomQueryRunSingleQueryStep = () => {
        const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY);
        const step = {
            procedure: {
                id: extractionStepTemplate?.procedure.id,
                label: extractionStepTemplate?.procedure.label,
                name: extractionStepTemplate?.procedure.name
            },
            parameters: [
                ...extractionStepTemplate.parameters.map((p) => {
                    let value;
                    switch (p.name) {
                        case CUSTOM_QUERY_STEP_PARAMETERS.SELECT_GROUP_CODE:
                            value = selectedCustomQueryGroupCode ? selectedCustomQueryGroupCode : "";
                            break;
                        case CUSTOM_QUERY_STEP_PARAMETERS.SELECT_CATEGORY:
                            value = selectedQueryCategory ? selectedQueryCategory : "";
                            break;
                        case CUSTOM_QUERY_STEP_PARAMETERS.SELECT_QUERY:
                            value = queryId ? queryId : "";
                            break;
                        case CUSTOM_QUERY_STEP_PARAMETERS.CREATE_TABLE:
                            value = createTable ? createTable : false;
                            break;
                        case CUSTOM_QUERY_STEP_PARAMETERS.INPUT_FIELDS:
                            value = inputFields ? inputFields : [];
                            break;
                        default:
                            value = "";
                            break;
                    }

                    return {
                        ...p,
                        value: value
                    }
                })]
        }

        return step;
    }

    const getImportFromFileRepositoryStep = () => {
        const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY);

        const step = {
            procedure: {
                id: extractionStepTemplate.procedure.id,
                label: extractionStepTemplate.procedure.label
            },
            parameters: [
                ...extractionStepTemplate.parameters.map((p) => {
                    let value;
                    switch (p.name) {
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.FILE_PATH:
                            value = `${selectedProjectSource.locationPath}/${selectedFileName}`;
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
                            value = selectedGroupCode ? selectedGroupCode : "";
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_ENTITY:
                            value = selectedEntity ? selectedEntity : "";
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_DATABASE:
                            value = database ? database : "";
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_SCHEMA:
                            value = schema ? schema : "";
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
                            value = name ? name : "";
                            break;
                        case IMPORT_FROM_FILE_REPOSITORY_STEP_PARAMETERS.SYSTEM_ID:
                            value = selectedSystemId;
                            break;
                        default:
                            value = "";
                            break;
                    }

                    return {
                        ...p,
                        value: value
                    }
                })]
        }

        return step;
    }

    const getImportFromSharePointStep = () => {
        const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT);

        const step = {
            procedure: {
                id: extractionStepTemplate.procedure.id,
                label: extractionStepTemplate.procedure.label
            },
            parameters: [
                ...extractionStepTemplate.parameters.map((p) => {
                    let value;
                    switch (p.name) {
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.FILE_PATH:
                            value = `${selectedProjectSource.server}/${sharepointFileNames.find(f => f.name === selectedFileName).id}`;
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
                            value = selectedGroupCode ? selectedGroupCode : "";
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_ENTITY:
                            value = selectedEntity ? selectedEntity : "";
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_DATABASE:
                            value = database ? database : "";
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_SCHEMA:
                            value = schema ? schema : "";
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
                            value = name ? name : "";
                            break;
                        case IMPORT_FROM_SHAREPOINT_STEP_PARAMETERS.SYSTEM_ID:
                            value = selectedSystemId;
                            break;
                        default:
                            value = "";
                            break;
                    }

                    return {
                        ...p,
                        value: value
                    }
                })]
        }

        return step;
    }

    const getImportFromMsSqlStep = () => {
        const selectedDataSource = projectSources.find(
            (x: any) => x.id.toString() === selectedProjectDataSource
        );

        const step = {
            procedure: {
                id: selectedStepTemplate.procedure.id,
                label: selectedStepTemplate.procedure.label
            },
            parameters: [
                ...selectedStepTemplate.parameters.map((p) => {
                    let value;
                    switch (p.name) {
                        case EXTRACTION_STEP_PARAMETERS.SOURCE_TYPE:
                            value = "MS SQL";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.FILE_NAME:
                            value = "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.SOURCE_ID:
                            value = selectedDataSource.id.toString();
                            break;
                        case EXTRACTION_STEP_PARAMETERS.SOURCE_TABLE_NAME:
                            value = importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT ? selectedDatabaseObject : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.SOURCE_QUERY:
                            value = importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY ? sourceQuery.replace(/'/g, "''") : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.DESTINATION_SCHEMA:
                            value = schema ? schema : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.DESTINATION_TABLE_NAME:
                            value = name ? name : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.DESTINATION_ENTITY:
                            value = stepEntity ? stepEntity : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.DESTINATION_GROUP_CODE:
                            value = stepGroupCode ? stepGroupCode : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.DESTINATION_DATABASE:
                            value = database ? database : "";
                            break;
                        case EXTRACTION_STEP_PARAMETERS.SYSTEM_ID:
                            value = selectedSystemId;
                            break;
                        default:
                            value = "";
                            break;
                    }

                    return {
                        ...p,
                        value: value
                    }

                })]
        };

        return step;
    };

    const onFRProjectDataSourceSelect = (value: string, option: any) => {
        setTestConnectionState(null);
        setSelectedFRProjectDataSource(option);

        getFileNamesFromRepository(option);

        if (option && current === 1) {
            next();
        }
    };

    const getFileNamesFromRepository = (projectDataSource: any) => {
        const selectedProjectSource = projectSources.find(
            (x: any) => x.id === +projectDataSource.id
        );
        setSelectedProjectSource(selectedProjectSource);

        ExtractionService.getFileNamesFromRepository(selectedProjectSource.locationPath).then((response) => {
            setFileRepositoryFileNames(response.data);
        });
    }

    const onSPProjectDataSourceSelect = (value: string, option: any) => {
        setTestConnectionState(null);
        setSelectedFRProjectDataSource(option);

        getFileNamesFromSharePoint(option);

        if (option && current === 1) {
            next();
        }
    };

    const getFileNamesFromSharePoint = (projectDataSource: any) => {
        const selectedProjectSource = projectSources.find(
            (x: any) => x.id === +projectDataSource.id
        );
        setSelectedProjectSource(selectedProjectSource);

        ExtractionService.getSharePointFiles(selectedProjectSource.locationPath, selectedProjectSource.id).then((response) => {
            setSharepointFileNames(response.data);
        });
    }

    const testFileRepositoryPath = async () => {
        ExtractionService.testFileRepositoryConnection(selectedProjectSource.locationPath).then((response) => {
            setTestConnectionState(response.data);
        });
    };

    const testSharePointConnection = async () => {
        ExtractionService.testSharePointConnection('', '', '', '', '', selectedProjectSource.id).then((response) => {
            setTestConnectionState(response.data);
        });
    };

    const onFileNameChange = (value) => {
        setSelectedFileName(value);
    }

    return (
        <div>
            <PageHead
                title={t(
                    "Page.BatchProcessing.ProcessOverview.Headers.ProcessOverview",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Process overview",
                    }
                )}
                icon={<ApartmentOutlined />}
                routes={routes}
                groupCodes={groupCodes}
                entities={entities}
                operations={[]}
                selectedGroupCode={selectedGroupCode}
                selectedEntity={selectedEntity}
                selectedOperation={undefined}
                setSelectedGroupCode={setSelectedGroupCode}
                setSelectedEntity={setSelectedEntity}
                setSelectedOperation={undefined}
                setSelectGroupCodeDisabled={false}
                setSelectEntityDisabled={false}
                setSelectOperationDisabled={true}
                mainAction={actionButton}
                otherActions={[]}
                setActionsDisabled={false}
            />
            <div className="card-container">
                <Tabs
                    type="card"
                >
                    <TabPane
                        tab={t("Page.BatchProcessing.ProcessOverview.Tabs.UserProcesses", {
                            lngs: i18n.languages,
                            defaultValue: "User processes",
                        })}
                        key="user-processes"
                    >
                        <Datatable
                            scroll={scroll}
                            tableColumns={columns}
                            data={userProcesses}
                            setData={setData}
                            otherActions={getTaskActions}
                            otherRowEnabled={true}
                            isTableLoading={isTableLoading}
                            editRowEnabled={false}
                            copyRowEnabled={false}
                            deleteRowEnabled={false}
                            onEditFunc={undefined}
                            onCopyFunc={undefined}
                            onDeleteFunc={undefined}
                            onDoubleClickRow={openViewStepsDrawer}
                            multiSelect={multiSelect}
                            checkPermissions={true}
                            selectable={selectable}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                        />
                    </TabPane>
                    <TabPane
                        tab={t("Page.BatchProcessing.ProcessOverview.Tabs.SystemProcesses", {
                            lngs: i18n.languages,
                            defaultValue: "System processes",
                        })}
                        key="system-processes"
                    >
                        <Datatable
                            scroll={scroll}
                            tableColumns={columns}
                            data={systemProcesses}
                            setData={setData}
                            otherActions={getTaskActions}
                            otherRowEnabled={true}
                            isTableLoading={isTableLoading}
                            editRowEnabled={false}
                            copyRowEnabled={false}
                            deleteRowEnabled={false}
                            onEditFunc={undefined}
                            onCopyFunc={undefined}
                            onDeleteFunc={undefined}
                            onDoubleClickRow={openViewStepsDrawer}
                            multiSelect={multiSelect}
                            checkPermissions={true}
                            selectable={selectable}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                        />
                    </TabPane>
                </Tabs>
            </div>
            <Drawer
                width={"400px"}
                title={selectedTask ? selectedTask.name : ""}
                closable={false}
                visible={showViewStepsDrawer}
                height={"500px"}
                getContainer={false}
                style={{ position: "absolute", transform: "none" }}
                placement={placement}
                onClose={onCloseViewStepsDrawer}
                bodyStyle={{
                    display: "flex",
                    flexDirection: "row",
                    transform: "none",
                }}
            >  
                {isDrawerLoading ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",           
                            minHeight: 200           
                        }}
                    >
                        <Spin tip={t("Page.BatchProcessing.ProcessOverview.Details.Loading", {
                            lngs: i18n.languages,
                            defaultValue: "Loading task details, please wait...",
                        })} />
                    </div>
            ) : (
                <Datatable
                    scroll={scroll}
                    tableColumns={stepsColumns}
                    data={selectedTask?.steps}
                    setData={setData}
                    isTableLoading={false}
                    otherActions={getStepActions}
                    otherRowEnabled={true}
                    editRowEnabled={false}
                    copyRowEnabled={false}
                    deleteRowEnabled={false}
                    onEditFunc={undefined}
                    onCopyFunc={undefined}
                    onDeleteFunc={undefined}
                    onDoubleClickRow={() => undefined}
                    selectable={false}
                    multiSelect={false}
                    selectedRows={[]}
                    setSelectedRows={undefined}
                    checkPermissions={true}
                ></Datatable>
                )}
                {showViewStepsParamsDrawer && (
                    <Drawer
                        title={t(
                            "Page.BatchProcessing.ProcessOverview.Labels.StepParameters",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Step parameters",
                            }
                        )}
                        width="600px"
                        closable={false}
                        onClose={onCloseViewStepsParamsDrawer}
                        visible={showViewStepsParamsDrawer}
                        getContainer={false}
                        style={{ position: "absolute" }}
                        extra={
                            <Space>
                                <Button
                                    type="ghost"
                                    onClick={onCloseViewStepsParamsDrawer}
                                    icon={<CloseOutlined />}
                                    size="small"
                                />
                            </Space>
                        }
                    >
                        <Form>
                            {selectedStepParameters.map((param: any) => (
                                <Form.Item className="stepParams" label={param?.name}>
                                    {param?.value}
                                </Form.Item>
                            ))}
                        </Form>
                    </Drawer>
                )}
                {isLogsTableVisible && (
                    <Drawer
                        width={"400px"}
                        title={selectedStep?.name ?? ""}
                        closable={false}
                        visible={isLogsTableVisible}
                        height={"500px"}
                        getContainer={false}
                        style={{ position: "absolute", transform: "none" }}
                        placement={placement}
                        onClose={onCloseViewStepLogsDrawer}
                        bodyStyle={{
                            display: "flex",
                            flexDirection: "row",
                            transform: "none",
                        }}
                        extra={
                            <Space>
                                <Button
                                    type="ghost"
                                    onClick={downloadProcedureOutput}
                                    icon={<DownloadOutlined />}
                                    size="small"
                                >
                                    {t("General.Labels.Download", {
                                        lngs: i18n.languages,
                                        defaultValue: "Download",
                                    })}
                                </Button>
                                <Button
                                    type="ghost"
                                    onClick={onCloseViewStepLogsDrawer}
                                    icon={<CloseOutlined />}
                                    size="small"
                                />
                            </Space>
                        }
                    >

                        <Tabs defaultActiveKey="mapping-log" onChange={(tab) => setLogActiveTab(tab)}>
                            <Tabs.TabPane tab="Mapping.Log" key="mapping-log">
                                <Datatable
                                    scroll={scroll}
                                    tableColumns={logsColumns}
                                    data={selectedStep?.logs}
                                    setData={setSelectedStepLogs}
                                    isTableLoading={false}
                                    otherActions={() => undefined}
                                    otherRowEnabled={true}
                                    showActionsColumn={false}
                                    editRowEnabled={false}
                                    copyRowEnabled={false}
                                    deleteRowEnabled={false}
                                    onEditFunc={undefined}
                                    onCopyFunc={undefined}
                                    onDeleteFunc={undefined}
                                    onDoubleClickRow={() => undefined}
                                    selectable={false}
                                    multiSelect={false}
                                    selectedRows={[]}
                                    setSelectedRows={undefined}
                                    checkPermissions={true}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Procedure output" key="procedure-output">
                                <Datatable
                                    scroll={scroll}
                                    tableColumns={logsColumns}
                                    data={selectedStep?.procedureOutputLogs}
                                    setData={setSelectedStepLogs}
                                    isTableLoading={false}
                                    otherActions={() => undefined}
                                    otherRowEnabled={true}
                                    showActionsColumn={false}
                                    editRowEnabled={false}
                                    copyRowEnabled={false}
                                    deleteRowEnabled={false}
                                    onEditFunc={undefined}
                                    onCopyFunc={undefined}
                                    onDeleteFunc={undefined}
                                    onDoubleClickRow={() => undefined}
                                    selectable={false}
                                    multiSelect={false}
                                    selectedRows={[]}
                                    setSelectedRows={undefined}
                                    checkPermissions={true}
                                />
                            </Tabs.TabPane>
                        </Tabs>
                    </Drawer>
                )}
            </Drawer>
            <Drawer
                width={"400px"}
                title={!selectedTask || (selectedTask && selectedTask.status !== "Scheduled" && selectedTask.status !== "In Queue")
                    ? t("Page.BatchProcessing.ProcessOverview.Labels.NewTask", {
                        lngs: i18n.languages,
                        defaultValue: "New Task",
                    })
                    : t("Page.BatchProcessing.ProcessOverview.Labels.EditTask", {
                        lngs: i18n.languages,
                        defaultValue: "Edit Task",
                    })}
                closable={false}
                visible={openDrawer}
                height={"500px"}
                getContainer={false}
                style={{ position: "absolute", transform: "none" }}
                placement={placement}
                onClose={onClose}
                bodyStyle={{
                    display: "flex",
                    flexDirection: "row",
                    transform: "none",
                }}
                extra={
                    <Space>
                        <Button
                            onClick={createTask}
                            icon={<CheckOutlined />}
                            size="small"
                            disabled={
                                !taskEntity ||
                                !taskGroupCode ||
                                !taskNameInput ||
                                steps.length <= 0
                            }
                            loading={buttonLoading}
                        >
                            {t("General.Labels.Save", {
                                lngs: i18n.languages,
                                defaultValue: "Save",
                            })}
                        </Button>
                        <Button
                            type="ghost"
                            onClick={onClose}
                            icon={<CloseOutlined />}
                            size="small"
                        />
                    </Space>
                }
            >
                <div className="form_group">
                    <Title level={5}>
                        {t("Page.BatchProcessing.ProcessOverview.Labels.General", {
                            lngs: i18n.languages,
                            defaultValue: "General",
                        })}
                    </Title>
                    <Form layout="vertical">
                        <Form.Item
                            label={t("Page.BatchProcessing.ProcessOverview.Labels.Name", {
                                lngs: i18n.languages,
                                defaultValue: "Name:",
                            })}
                            tooltip={t("Page.BatchProcessing.ProcessOverview.Tooltips.Name", {
                                lngs: i18n.languages,
                                defaultValue: "",
                            })}
                            required
                        >
                            <Input
                                allowClear
                                value={taskNameInput}
                                placeholder={
                                    t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                    })!
                                }
                                onChange={onTaskNameInputChange}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label={t(
                                "Page.BatchProcessing.ProcessOverview.Labels.GroupCode",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "Group Code:",
                                }
                            )}
                            tooltip={t(
                                "Page.BatchProcessing.ProcessOverview.Tooltips.GroupCode",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                }
                            )}
                            required
                        >
                            <Select
                                placeholder={t("General.Placeholders.SelectOption", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select option",
                                })}
                                allowClear
                                showSearch
                                value={taskGroupCode}
                                onChange={handleGroupCodeChange}
                                options={groupCodes.map((x: any) => ({
                                    label: x.code,
                                    value: x.code,
                                }))}
                                filterSort={(optionA, optionB) =>
                                    (optionA!.label as unknown as string)
                                        .toLowerCase()
                                        .localeCompare(
                                            (optionB!.label as unknown as string).toLowerCase()
                                        )
                                }
                                filterOption={(inputValue: any, option: any) =>
                                    option!.label
                                        .toUpperCase()
                                        .indexOf(inputValue.toUpperCase()) !== -1
                                }
                            ></Select>
                        </Form.Item>
                        <Form.Item
                            label={t("Page.BatchProcessing.ProcessOverview.Labels.Entity", {
                                lngs: i18n.languages,
                                defaultValue: "Entity:",
                            })}
                            tooltip={t(
                                "Page.BatchProcessing.ProcessOverview.Tooltips.Entity",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                }
                            )}
                            required
                        >
                            <Select
                                placeholder={t("General.Placeholders.SelectOption", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select option",
                                })}
                                allowClear
                                showSearch
                                value={taskEntity}
                                onChange={handleEntityChange}
                                options={entities.map((x: any) => ({
                                    label: x.name,
                                    value: x.id,
                                }))}
                                filterSort={(optionA, optionB) =>
                                    (optionA!.label as unknown as string)
                                        .toLowerCase()
                                        .localeCompare(
                                            (optionB!.label as unknown as string).toLowerCase()
                                        )
                                }
                                filterOption={(inputValue: any, option: any) =>
                                    option!.label
                                        .toUpperCase()
                                        .indexOf(inputValue.toUpperCase()) !== -1
                                }
                            ></Select>
                        </Form.Item>
                    </Form>
                </div>
                <Divider type="vertical" style={{ height: "100%" }} />
                <div className="form_group">
                    <Title level={5}>
                        {t("Page.BatchProcessing.ProcessOverview.Labels.AddSteps", {
                            lngs: i18n.languages,
                            defaultValue: "Add Steps",
                        })}
                    </Title>
                    <Form layout="vertical">
                        <Form.Item
                            label={t("Page.BatchProcessing.ProcessOverview.Labels.Steps", {
                                lngs: i18n.languages,
                                defaultValue: "Steps:",
                            })}
                            tooltip={t(
                                "Page.BatchProcessing.ProcessOverview.Tooltips.Steps",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                }
                            )}
                        >
                            <Button
                                block
                                onClick={openAddStepsDrawer}
                                icon={<PlusOutlined />}
                                style={{
                                    backgroundColor: "var(--accent)",
                                    color: "white",
                                    borderRadius: "2px",
                                }}
                                disabled={!taskEntity && !taskGroupCode}
                            >
                                {t(
                                    "Page.BatchProcessing.ProcessOverview.Labels.ActionAddStep",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue: "Add Step",
                                    }
                                )}
                            </Button>
                        </Form.Item>
                        {steps && steps.length > 0 && (
                            <DragDropContext onDragEnd={handleOnDragEnd}>
                                <Droppable droppableId="DropId">
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                            <List
                                                className="taskMenu"
                                                rowKey={(item: any) => item?.procedure?.id ?? 'defaultKey'
                                                }
                                                dataSource={steps}
                                                size="small"
                                                renderItem={(item: any, index: any) => (
                                                    <Draggable
                                                        draggableId={`draggable-${index}`}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                className="taskMenu"
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <List.Item>
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            gap: "10px",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <MenuOutlined
                                                                            style={{ color: "var(--accent)" }}
                                                                        />
                                                                        {item?.procedure?.label}
                                                                    </div>
                                                                    <div>
                                                                        <EditOutlined
                                                                            style={{ color: "var(--primary)" }}
                                                                            onClick={() => editStep(item, false)}
                                                                        />
                                                                        <CloseCircleOutlined
                                                                            style={{
                                                                                color: "var(--primary)",
                                                                                marginLeft: 10,
                                                                            }}
                                                                            onClick={() => removeStep(item)}
                                                                        />
                                                                    </div>
                                                                </List.Item>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )}
                                            />
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )}
                        {steps.map((step: any) => {
                            <Form.Item
                                label={t("Page.BatchProcessing.ProcessOverview.Labels.Steps", {
                                    lngs: i18n.languages,
                                    defaultValue: "Steps:",
                                })}
                                tooltip={t(
                                    "Page.BatchProcessing.ProcessOverview.Tooltips.Steps",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    }
                                )}
                            >
                                <Button
                                    block
                                    onClick={openAddStepsDrawer}
                                    icon={<PlusOutlined />}
                                    style={{
                                        backgroundColor: "var(--accent)",
                                        color: "white",
                                        borderRadius: "2px",
                                    }}
                                >
                                    {t(
                                        "Page.BatchProcessing.ProcessOverview.Labels.ActionAddStep",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Add Step",
                                        }
                                    )}
                                </Button>
                            </Form.Item>;
                        })}
                    </Form>
                </div>
                <Divider type="vertical" style={{ height: "100%" }} />
                <div className="form_group">
                    <Title level={5}>
                        {t(
                            "Page.BatchProcessing.ProcessOverview.Labels.ScheduleExecution",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Schedule execution",
                            }
                        )}
                    </Title>
                    <Form layout="vertical">
                        <Form.Item
                            label={t(
                                "Page.BatchProcessing.ProcessOverview.Labels.Occurrence",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "Occurrence:",
                                }
                            )}
                            tooltip={t(
                                "Page.BatchProcessing.ProcessOverview.Tooltips.Occurrence",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                }
                            )}
                        >
                            <Select
                                style={{ marginBottom: "24px" }}
                                placeholder={t("General.Placeholders.SelectOption", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select option",
                                })}
                                allowClear
                                value={scheduleType}
                                onChange={setScheduleType}
                            >
                                <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.IMMEDIATELY}>
                                    {t(
                                        "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Immediately",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Immediately",
                                        }
                                    )}
                                </Option>
                                <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.ONE_TIME}>
                                    {t(
                                        "Page.BatchProcessing.ProcessOverview.OptionOccurrence.OneTime",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "One Time",
                                        }
                                    )}
                                </Option>
                                <Option value={BATCH_PROCESSING_OCCURRENCE_TYPE.RECURRING}>
                                    {t(
                                        "Page.BatchProcessing.ProcessOverview.OptionOccurrence.Recurring",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Recurring",
                                        }
                                    )}
                                </Option>
                            </Select>
                            <PickerWithType
                                type={scheduleType}
                                onChange={(value: any) => console.log(value)}
                            />
                        </Form.Item>
                    </Form>
                </div>
                <Divider type="vertical" style={{ height: "100%" }} />
                <div className="form_group">
                    <Title level={5}>
                        {t("Page.BatchProcessing.ProcessOverview.Labels.Reporting", {
                            lngs: i18n.languages,
                            defaultValue: "Reporting",
                        })}
                    </Title>
                    <Form layout="vertical">
                        <Form.Item
                            label={t("Page.BatchProcessing.ProcessOverview.Labels.Email", {
                                lngs: i18n.languages,
                                defaultValue: "Email:",
                            })}
                            tooltip={t(
                                "Page.BatchProcessing.ProcessOverview.Tooltips.Email",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                }
                            )}
                        >
                            <Input
                                allowClear
                                value={emailInput}
                                placeholder={
                                    t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                    })!
                                }
                                onChange={onEmailInputChange}
                            ></Input>
                        </Form.Item>
                        <Form.Item>
                            <Checkbox>
                                {t("Page.BatchProcessing.ProcessOverview.Labels.Attachment", {
                                    lngs: i18n.languages,
                                    defaultValue: "Attachment",
                                })}
                            </Checkbox>
                        </Form.Item>
                    </Form>
                </div>
            </Drawer>
            <Drawer
                title={editStepIndex === -1
                    ? t("Page.BatchProcessing.ProcessOverview.Labels.NewStep", {
                        lngs: i18n.languages,
                        defaultValue: "New Step",
                    })
                    : t("Page.BatchProcessing.ProcessOverview.Labels.EditStep", {
                        lngs: i18n.languages,
                        defaultValue: "Edit Step",
                    })}
                width="600px"
                closable={false}
                onClose={onCloseStepsDrawer}
                visible={showStepsDrawer}
                getContainer={false}
                style={{ position: "absolute" }}
                extra={
                    <Space>
                        <Button
                            disabled={!saveStepAllowed}
                            onClick={saveStep}
                            icon={<CheckOutlined />}
                            size="small"
                        >
                            {editStepIndex === -1
                                ? t("General.Labels.Add", {
                                    lngs: i18n.languages,
                                    defaultValue: "Add",
                                })
                                : t("General.Labels.Save", {
                                    lngs: i18n.languages,
                                    defaultValue: "Save",
                                })}
                        </Button>
                        <Button
                            type="ghost"
                            onClick={onCloseStepsDrawer}
                            icon={<CloseOutlined />}
                            size="small"
                        />
                    </Space>
                }
            >
                <Form layout="vertical">
                    <Form.Item
                        label={t("Page.BatchProcessing.ProcessOverview.Labels.Step", {
                            lngs: i18n.languages,
                            defaultValue: "Step:",
                        })}
                        tooltip={t("Page.BatchProcessing.ProcessOverview.Tooltips.Step", {
                            lngs: i18n.languages,
                            defaultValue: "",
                        })}
                    >
                        <Select
                            disabled={showViewStepsDrawer}
                            style={{ width: "100%" }}
                            placeholder={t("General.Placeholders.SelectOption", {
                                lngs: i18n.languages,
                                defaultValue: "Select option",
                            })}
                            allowClear
                            showSearch
                            value={
                                selectedStepTemplate
                                    ? selectedStepTemplate?.procedure?.id
                                    : null
                            }
                            onChange={(value: any) =>
                                setSelectedStepTemplate(
                                    stepTemplates.find((x: any) => x.procedure.id === value)
                                )
                            }
                            options={stepTemplates.map((stepTemplate: any) => ({
                                label: stepTemplate.procedure.label,
                                value: stepTemplate.procedure.id,
                                position: stepTemplate.procedure.position,
                            }))}
                            filterSort={(optionA, optionB) => optionA.position - optionB.position}
                            // filterSort={(optionA, optionB) =>
                            //     (optionA!.label as unknown as string)
                            //         .toLowerCase()
                            //         .localeCompare(
                            //             (optionB!.label as unknown as string).toLowerCase()
                            //         )
                            // }
                            filterOption={(inputValue: any, option: any) =>
                                option!.label
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                            }
                        ></Select>
                    </Form.Item>

                    {selectedStepTemplate && selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY && (
                        <>
                            <Form.Item
                                label={t("Page.Operation.Extraction.Labels.SelectGroupCode", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select query group code:",
                                })}
                                required
                                tooltip={t("Page.Operation.Extraction.Tooltips.SelectGroupCode", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select query group code",
                                })}
                            >
                                <Select
                                    showSearch={true}
                                    showArrow={true}
                                    allowClear={true}
                                    value={selectedCustomQueryGroupCode}
                                    onSelect={onCustomQueryGroupCodeChange}
                                    style={{ flex: 2 }}
                                    placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                    })}
                                    options={groupCodes.map((x: any) => ({
                                        label: x.code,
                                        value: x.code,
                                    }))}
                                    filterOption={(inputValue: any, option: any) =>
                                        option!.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                label={t("Page.Report.CustomQueries.Labels.Select.Category", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select query category:",
                                })}
                                required
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder={t("General.Placeholders.SelectOption", {
                                        lngs: i18n.languages,
                                        defaultValue: "Select option",
                                    })}
                                    options={queryCategories.map((x: any) => ({
                                        label: x.value,
                                        value: x.index,
                                    }))}
                                    value={selectedQueryCategory}
                                    onChange={onSelectedQueryCategoryChange}
                                    filterSort={(optionA, optionB) =>
                                        (optionA!.label as unknown as string)
                                            .toLowerCase()
                                            .localeCompare((optionB!.label as unknown as string).toLowerCase())
                                    }
                                    filterOption={(inputValue: any, option: any) =>
                                        option!.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />

                            </Form.Item>
                        </>
                    )}
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY &&
                        selectedCustomQueryGroupCode && selectedQueryCategory && current >= 2 &&
                        (
                            <Form.Item
                                label={t("Page.Report.CustomQueries.Labels.Select.QueryType", {
                                    lngs: i18n.languages,
                                    defaultValue: "Select query:",
                                })}
                                tooltip={t("Page.Report.CustomQueries.Tooltips.Select.QueryType", {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                })}
                                required
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder={selectedQuery || "Select option"}
                                    options={queries.map((x: any) => ({
                                        label: x.value,
                                        value: x.id + ' ' + x.label,
                                    }))}
                                    value={queryId ? `${queryId} ${queries.find((x: any) => x.id.toString() === queryId)?.label}` : undefined}
                                    onChange={onSelectedQueryChange}
                                    filterSort={(optionA, optionB) => {
                                        const labelA = optionA!.label as string | undefined;
                                        const labelB = optionB!.label as string | undefined;

                                        if (labelA && labelB) {
                                            const numA = parseFloat(labelA);
                                            const numB = parseFloat(labelB);

                                            if (!isNaN(numA) && !isNaN(numB)) {
                                                return numA - numB;
                                            }

                                            return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
                                        }

                                    }}
                                />
                            </Form.Item>
                        )}
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY &&
                        current >= 3 && selectedQuery && (
                            <Form.Item
                                required
                            >
                                <Checkbox
                                    checked={createTable}
                                    onChange={onCreateTableChange}
                                >
                                    Create Table
                                </Checkbox>
                            </Form.Item>
                        )}
                    {selectedStepTemplate && selectedStepTemplate.procedure.label === CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY &&
                        current >= 4 &&
                        (
                            <>
                                {inputFields.map((field, index) => (
                                    <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                        <Input
                                            value={field.key}
                                            onChange={(e) => handleInputChange(index, e)}
                                            name="key"
                                            readOnly={field.readOnly}
                                        />
                                        <Input
                                            value={field.value}
                                            onChange={(e) => handleInputChange(index, e)}
                                            name="value"
                                            readOnly={field.readOnly}
                                        />
                                        <Button
                                            icon={<CloseOutlined />}
                                            type="text"
                                            onClick={() => handleRemoveFields(index)}>
                                        </Button>

                                    </div>
                                ))}
                                <Button type="dashed" onClick={handleAddFields}>
                                    Add New
                                </Button>
                            </>
                        )}
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE && (
                            <Form.Item
                                label={t(
                                    "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue: "Select project data source:",
                                    }
                                )}
                                required
                                tooltip={t(
                                    "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                                    { lngs: i18n.languages, defaultValue: "" }
                                )}
                            >
                                <Select
                                    showSearch={true}
                                    showArrow={true}
                                    allowClear={true}
                                    value={selectedProjectDataSource}
                                    onSelect={onProjectDataSourceChange}
                                    style={{ flex: 2 }}
                                    placeholder={t("General.Placeholders.EnterValue", {
                                        lngs: i18n.languages,
                                        defaultValue: "Enter value",
                                    })}
                                    options={projectSources
                                        .filter((x: any) => x.sourceTypeID === 2)
                                        .map((x: any) => {
                                            return {
                                                value: x.id.toString(),
                                                label: x.name,
                                                id: x.id.toString(),
                                            };
                                        })}
                                    filterOption={(inputValue: any, option: any) =>
                                        option!.label
                                            .toUpperCase()
                                            .indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                >
                                </Select>
                            </Form.Item>
                        )}
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE &&
                        current >= 2 &&
                        selectedProjectDataSource && (
                            <>
                                <Form.Item>
                                    <Button
                                        icon={<ExperimentOutlined />}
                                        onClick={() => testConnection()}
                                    >
                                        Test connection
                                    </Button>
                                    {testConnectionState && testConnectionState === true && (
                                        <span style={{ color: "green" }}>
                                            Test connection succeeded.
                                        </span>
                                    )}
                                    {testConnectionState === false && (
                                        <span style={{ color: "red" }}>
                                            Test connection failed.
                                        </span>
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Extraction.Labels.SelectImportType",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Select import type:",
                                        }
                                    )}
                                    required
                                    tooltip={t(
                                        "Page.Operation.Extraction.Tooltips.SelectImportType",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        value={importType}
                                        onSelect={onImportTypeChange}
                                        style={{ flex: 2 }}
                                        placeholder={t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                        })}
                                        options={importTypes}
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    >
                                    </Select>
                                </Form.Item>
                            </>
                        )
                    }
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE &&
                        current >= 3 && (
                            <>
                                {importType === EXTRACTION_IMPORT_TYPES.DATABASE_OBJECT && (
                                    <Form.Item
                                        label={t(
                                            "Page.Operation.Extraction.Labels.SelectDatabaseObject",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Select database object:",
                                            }
                                        )}
                                        required
                                        tooltip={t(
                                            "Page.Operation.Extraction.Tooltips.SelectDatabaseObject",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <AutoComplete
                                            disabled={current !== 3}
                                            showSearch={true}
                                            showArrow={true}
                                            allowClear={true}
                                            value={selectedDatabaseObject}
                                            onSelect={onSelectedDatabaseObjectSelect}
                                            onChange={onSelectedDatabaseObjectChange}
                                            style={{ flex: 2 }}
                                            placeholder={t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })}
                                            options={databaseTables.map((x: any) => ({
                                                value: x,
                                                label: x,
                                            }))}
                                            filterOption={(inputValue: any, option: any) =>
                                                option!.value
                                                    .toUpperCase()
                                                    .indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                        ></AutoComplete>
                                    </Form.Item>
                                )}
                                {importType === EXTRACTION_IMPORT_TYPES.CUSTOM_QUERY && (
                                    <Form.Item
                                        label={t(
                                            "Page.Operation.Extraction.Labels.SourceQuery",
                                            { lngs: i18n.languages, defaultValue: "Source query:" }
                                        )}
                                        tooltip={t(
                                            "Page.Operation.Extraction.Tooltips.SourceQuery",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                        required
                                    >
                                        <TextArea
                                            value={sourceQuery}
                                            placeholder={
                                                t("General.Placeholders.EnterValue", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Enter value",
                                                })!
                                            }
                                            rows={5}
                                            allowClear
                                            onChange={onSourceQueryChange}
                                        />
                                    </Form.Item>
                                )}
                                <Form.Item
                                    label={t("Page.Operation.Extraction.Labels.GroupCode", {
                                        lngs: i18n.languages,
                                        defaultValue: "Group code:",
                                    })}
                                    required
                                    tooltip={t("Page.Operation.Extraction.Tooltips.GroupCode", {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    })}
                                >
                                    <Select
                                        disabled={current !== 3}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        onChange={onGroupCodeChange}
                                        value={stepGroupCode}
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        options={groupCodes.map((x: any) => ({
                                            label: x.code,
                                            value: x.code,
                                        }))}
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Operation.Extraction.Labels.Entity", {
                                        lngs: i18n.languages,
                                        defaultValue: "Entity:",
                                    })}
                                    required
                                    tooltip={t("Page.Operation.Extraction.Tooltips.Entity", {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    })}
                                >
                                    <Select
                                        disabled={current !== 3}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        onChange={onEntityChange}
                                        value={stepEntity}
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        options={entities.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        filterSort={(optionA: any, optionB: any) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "System:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                                        { lngs: i18n.languages, defaultValue: "" }
                                    )}
                                >
                                    <Select
                                        showSearch
                                        options={systems.map((x: System) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedSystemId}
                                        onChange={setSelectedSystemId}
                                        allowClear
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })!}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Operation.Extraction.Labels.Database", {
                                        lngs: i18n.languages,
                                        defaultValue: "Database:",
                                    })}
                                    required
                                    tooltip={t("Page.Operation.Extraction.Tooltips.Database", {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    })}
                                >
                                    <Select
                                        disabled={current !== 3}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        showSearch={true}
                                        showArrow={true}
                                        allowClear={true}
                                        value={database}
                                        onChange={onDatabaseChange}
                                        options={databases.map((x: any) => ({
                                            label: x.name,
                                            value: x.name,
                                        }))}
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Operation.Extraction.Labels.Schema", {
                                        lngs: i18n.languages,
                                        defaultValue: "Schema:",
                                    })}
                                    required
                                    tooltip={t("Page.Operation.Extraction.Tooltips.Schema", {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    })}
                                >
                                    <Input
                                        disabled={current !== 3}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            }) ?? "Enter value"
                                        }
                                        value={schema}
                                        onChange={(e) => onSchemaChange(e.target.value)}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Operation.Extraction.Labels.Name", {
                                        lngs: i18n.languages,
                                        defaultValue: "Name:",
                                    })}
                                    required
                                    tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    })}
                                >
                                    <Input
                                        disabled={current !== 3}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            }) ?? "Enter value"
                                        }
                                        value={name}
                                        onChange={(e) => onNameChange(e.target.value)}
                                    />
                                </Form.Item>
                            </>
                        )
                    }
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label !== CUSTOM_QUERY_PROCEDURE_NAMES.RUN_SINGLE_QUERY &&
                        selectedStepTemplate.procedure.label !== EXTRACTION_PROCEDURE_NAMES.IMPORT_SOURCE &&
                        selectedStepTemplate.procedure.label !== EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY &&
                        selectedStepTemplate.procedure.label !== EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT &&
                        selectedStepTemplate.parameters.map((param: any) => (
                            <Form.Item label={param.name + ":"}
                                required={param.isMandatory}
                                tooltip={t(param.tooltip, {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                })}>
                                {isDropdown(param.inputTypeId) && (
                                    <Select
                                        style={{ width: "100%" }}
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        allowClear
                                        showSearch
                                        value={param.value !== undefined && param.value !== null ? param.value : null}
                                        onChange={(value: any) =>
                                            onDropdownParamChange(param, value)
                                        }
                                        options={param.options.map((row: any) => ({
                                            label: row.name,
                                            value: row.value,
                                        }))}
                                        filterSort={(optionA, optionB) =>
                                            optionA.label! < optionB.label! ? -1 : 1
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    ></Select>
                                )}
                                {(isUserInput(param.inputTypeId) || isReadonly(param.inputTypeId)) && (
                                    <Input
                                        allowClear
                                        value={param.value}
                                        placeholder={
                                            t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })!
                                        }
                                        type={getParamType(param.valueTypeId)}
                                        readOnly={isReadonly(param.inputTypeId)}
                                        onChange={(event: any) =>
                                            onInputValueChange(param, event.target.value)
                                        }
                                    ></Input>
                                )}
                                {isDictionary(param.inputTypeId) && (
                                    <>
                                        {dictionaryFields.map((field, index) => (
                                            <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                                <Input
                                                    value={field.key}
                                                    onChange={(e) => handleDictionaryInputChange(index, e, param)}
                                                    name="key"
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    readOnly={field.readOnly}
                                                />
                                                <Input
                                                    value={field.value}
                                                    onChange={(e) => handleDictionaryInputChange(index, e, param)}
                                                    name="value"
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        })!
                                                    }
                                                    readOnly={field.readOnly}
                                                />
                                                <Button
                                                    icon={<CloseOutlined />}
                                                    type="text"
                                                    onClick={() => handleRemoveDictionaryFields(index)}>
                                                </Button>

                                            </div>
                                        ))}
                                        <Button type="dashed" onClick={handleAddDictionaryField}>
                                            Add New
                                        </Button>
                                    </>
                                )}
                            </Form.Item>
                        ))
                    }
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_FILE_REPOSITORY &&
                        (
                            <>
                                {current >= 1 && (
                                    <Form.Item
                                        label={t(
                                            "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Select project data source:",
                                            }
                                        )}
                                        required
                                        tooltip={t(
                                            "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <AutoComplete
                                            showSearch={true}
                                            showArrow={true}
                                            allowClear={true}
                                            onClear={() => setSelectedFRProjectDataSource(null)}
                                            value={selectedFRProjectDataSource}
                                            onSelect={onFRProjectDataSourceSelect}
                                            style={{ flex: 2 }}
                                            placeholder={t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })}
                                            options={projectSources
                                                .filter((x: any) => x.sourceTypeID === 1)
                                                .map((x: any) => {
                                                    return {
                                                        value: x.name,
                                                        label: x.name,
                                                        id: x.id.toString(),
                                                    };
                                                })
                                            }
                                            filterOption={(inputValue: any, option: any) =>
                                                option!.value
                                                    .toUpperCase()
                                                    .indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                        >
                                        </AutoComplete>
                                    </Form.Item>
                                )}
                                {current >= 2 &&
                                    selectedFRProjectDataSource && (
                                        <>
                                            <Form.Item>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testFileRepositoryPath()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testConnectionState &&
                                                    testConnectionState === true && (
                                                        <span style={{ color: "green" }}>
                                                            Test connection succeeded.
                                                        </span>
                                                    )}
                                                {testConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Operation.Extraction.Labels.SelectFile",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select file:",
                                                    }
                                                )}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.SelectFile",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    value={selectedFileName}
                                                    onSelect={onFileNameChange}
                                                    style={{ flex: 2 }}
                                                    placeholder={t("General.Placeholders.EnterValue", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Enter value",
                                                    })}
                                                    options={fileRepositoryFileNames.map(f => ({
                                                        id: f,
                                                        value: f
                                                    }))}
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                >
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.GroupCode", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Group code:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.GroupCode",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    onChange={onGroupCodeChange}
                                                    value={selectedGroupCode}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    options={groupCodes.map((x: any) => ({
                                                        label: x.code,
                                                        value: x.code,
                                                    }))}
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.value! < optionB.value! ? -1 : 1
                                                    }
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Entity", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Entity:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Entity",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    onChange={onEntityChange}
                                                    value={selectedEntity}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    options={entities.map((x: any) => ({
                                                        label: x.name,
                                                        value: x.id,
                                                    }))}
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                    filterSort={(optionA: any, optionB: any) =>
                                                        (optionA!.label as unknown as string)
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                (
                                                                    optionB!.label as unknown as string
                                                                ).toLowerCase()
                                                            )
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "System:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    showSearch
                                                    options={systems.map((x: System) => ({
                                                        label: x.name,
                                                        value: x.id,
                                                    }))}
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    value={selectedSystemId}
                                                    onChange={setSelectedSystemId}
                                                    allowClear
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })!}
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                name="database"
                                                label={t("Page.Operation.Extraction.Labels.Database", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Database:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Database",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    value={database}
                                                    onChange={onDatabaseChange}
                                                    options={databases.map((x: any) => ({
                                                        label: x.name,
                                                        value: x.name,
                                                    }))}
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.value! < optionB.value! ? -1 : 1
                                                    }
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Schema", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Schema:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Schema",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        }) ?? "Enter value"
                                                    }
                                                    value={schema}
                                                    onChange={(e) => onSchemaChange(e.target.value)}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Name", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Name:",
                                                })}
                                                required
                                                tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "",
                                                })}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        }) ?? "Enter value"
                                                    }
                                                    value={name}
                                                    onChange={(e) => onNameChange(e.target.value)}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                            </>
                        )
                    }
                    {selectedStepTemplate &&
                        selectedStepTemplate.procedure.label === EXTRACTION_PROCEDURE_NAMES.IMPORT_FROM_SHAREPOINT &&
                        (
                            <>
                                {current >= 1 && (
                                    <Form.Item
                                        label={t(
                                            "Page.Operation.Extraction.Labels.SelectProjectDataSource",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue: "Select project data source:",
                                            }
                                        )}
                                        required
                                        tooltip={t(
                                            "Page.Operation.Extraction.Tooltips.SelectProjectDataSource",
                                            { lngs: i18n.languages, defaultValue: "" }
                                        )}
                                    >
                                        <AutoComplete
                                            showSearch={true}
                                            showArrow={true}
                                            allowClear={true}
                                            onClear={() => setSelectedFRProjectDataSource(null)}
                                            value={selectedFRProjectDataSource}
                                            onSelect={onSPProjectDataSourceSelect}
                                            style={{ flex: 2 }}
                                            placeholder={t("General.Placeholders.EnterValue", {
                                                lngs: i18n.languages,
                                                defaultValue: "Enter value",
                                            })}
                                            options={projectSources
                                                .filter((x: any) => x.sourceTypeID === 3)
                                                .map((x: any) => {
                                                    return {
                                                        value: x.name,
                                                        label: x.name,
                                                        id: x.id.toString(),
                                                    };
                                                })
                                            }
                                            filterOption={(inputValue: any, option: any) =>
                                                option!.value
                                                    .toUpperCase()
                                                    .indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                        >
                                        </AutoComplete>
                                    </Form.Item>
                                )}
                                {current >= 2 &&
                                    selectedFRProjectDataSource && (
                                        <>
                                            <Form.Item>
                                                <Button
                                                    icon={<ExperimentOutlined />}
                                                    onClick={() => testSharePointConnection()}
                                                >
                                                    Test connection
                                                </Button>
                                                {testConnectionState &&
                                                    testConnectionState === true && (
                                                        <span style={{ color: "green" }}>
                                                            Test connection succeeded.
                                                        </span>
                                                    )}
                                                {testConnectionState === false && (
                                                    <span style={{ color: "red" }}>
                                                        Test connection failed.
                                                    </span>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Operation.Extraction.Labels.SelectFile",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select file:",
                                                    }
                                                )}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.SelectFile",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    value={selectedFileName}
                                                    onSelect={onFileNameChange}
                                                    style={{ flex: 2 }}
                                                    placeholder={t("General.Placeholders.EnterValue", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Enter value",
                                                    })}
                                                    options={sharepointFileNames.map(f => ({
                                                        id: f?.name,
                                                        value: f?.name
                                                    }))}
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                >
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.GroupCode", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Group code:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.GroupCode",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    onChange={onGroupCodeChange}
                                                    value={selectedGroupCode}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    options={groupCodes.map((x: any) => ({
                                                        label: x.code,
                                                        value: x.code,
                                                    }))}
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.value! < optionB.value! ? -1 : 1
                                                    }
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Entity", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Entity:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Entity",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    onChange={onEntityChange}
                                                    value={selectedEntity}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    options={entities.map((x: any) => ({
                                                        label: x.name,
                                                        value: x.id,
                                                    }))}
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                    filterSort={(optionA: any, optionB: any) =>
                                                        (optionA!.label as unknown as string)
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                (
                                                                    optionB!.label as unknown as string
                                                                ).toLowerCase()
                                                            )
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Labels.System",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "System:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Configuration.TableSetup.Tabs.TableSetup.Tooltips.System",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    showSearch
                                                    options={systems.map((x: System) => ({
                                                        label: x.name,
                                                        value: x.id,
                                                    }))}
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    value={selectedSystemId}
                                                    onChange={setSelectedSystemId}
                                                    allowClear
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })!}
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                name="database"
                                                label={t("Page.Operation.Extraction.Labels.Database", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Database:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Database",
                                                    { lngs: i18n.languages, defaultValue: "" }
                                                )}
                                            >
                                                <Select
                                                    placeholder={t("General.Placeholders.SelectOption", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Select option",
                                                    })}
                                                    showSearch={true}
                                                    showArrow={true}
                                                    allowClear={true}
                                                    value={database}
                                                    onChange={onDatabaseChange}
                                                    options={databases.map((x: any) => ({
                                                        label: x.name,
                                                        value: x.name,
                                                    }))}
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.value! < optionB.value! ? -1 : 1
                                                    }
                                                    filterOption={(inputValue: any, option: any) =>
                                                        option!.label
                                                            .toUpperCase()
                                                            .indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                ></Select>
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Schema", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Schema:",
                                                })}
                                                required
                                                tooltip={t(
                                                    "Page.Operation.Extraction.Tooltips.Schema",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        }) ?? "Enter value"
                                                    }
                                                    value={schema}
                                                    onChange={(e) => onSchemaChange(e.target.value)}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                label={t("Page.Operation.Extraction.Labels.Name", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Name:",
                                                })}
                                                required
                                                tooltip={t("Page.Operation.Extraction.Tooltips.Name", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "",
                                                })}
                                            >
                                                <Input
                                                    placeholder={
                                                        t("General.Placeholders.EnterValue", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Enter value",
                                                        }) ?? "Enter value"
                                                    }
                                                    value={name}
                                                    onChange={(e) => onNameChange(e.target.value)}
                                                />
                                            </Form.Item>
                                        </>
                                    )}
                            </>
                        )
                    }
                    {selectedStepTemplate && (
                        <Form.Item>
                            <div>
                                {t("Page.BatchProcessing.ProcessOverview.Labels.Procedure", {
                                    lngs: i18n.languages,
                                    defaultValue: "Procedure",
                                })}
                                : {selectedStepTemplate.procedure.name}
                            </div>
                        </Form.Item>
                    )}
                </Form>
            </Drawer>
            <TableDrawer
                title={t(
                    "Page.BatchProcessing.ProcessOverview.Drawers.Results",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Clustering Results",
                    }
                )}
                openDrawer={openResultsDrawer}
                columns={resultsColumns}
                tableData={resultsTableData}
                setTableData={setResultsTableData}
                isTableDataLoading={isResultsTableDataLoading}
                tablePageIndex={resultsTablePageIndex}
                setTablePageIndex={setResultsTablePageIndex}
                tablePageSize={resultsTablePageSize}
                setTablePageSize={setResultsTablePageSize}
                onExport={() => setShowExportDrawer(true)}
                onClose={() => setOpenResultsDrawer(false)}
            />
            <TableExport
                openDrawer={showExportDrawer}
                groupCodes={groupCodes}
                downloadTableData={downloadTableData}
                isDownloading={isDownloadingExportData}
                onClose={() => setShowExportDrawer(false)}
            />
        </div>
    );
};

export default ProcessOverview;
